import type { ILang } from '@core/interfaces/ILang';

const lang: ILang = {
  alert: {
    abort: 'Zrušit',
    buy: 'Koupit',
    cancel: 'Storno',
    caption: 'Chyba',
    close: 'Zavřít',
    confirm: 'Potvrdit',
    dont_save: 'Neukládat',
    dont_show_again: 'Znovu již nezobrazovat',
    duplicated_preset_name: 'Duplikované jméno předvolby',
    error: 'JEJDA',
    info: 'INFO',
    instruction: 'Instrukce',
    learn_more: 'Zjistit více',
    no: 'Ne',
    ok: 'OK',
    ok2: 'OK',
    oops: 'Jejky...',
    retry: 'Opakovat',
    save: 'Uložit',
    stop: 'Zastavit',
    warning: 'VAROVÁNÍ',
    yes: 'Ano',
  },
  auto_fit: {
    artwork_size: 'Velikost kresby',
    error_tip1: '1. Je kresba umístěna na materiálu správně?',
    error_tip2: '2. Jsou obrysy materiálu dostatečně jasné pro rozpoznání?',
    failed_to_find_contour: 'Nepodařilo se najít žádné obrysy pro automatické přizpůsobení',
    how_to_improve_accuracy: 'Jak zlepšit přesnost detekce?',
    how_to_improve_accuracy_url: 'https://support.flux3dp.com/hc/en-us/articles/15792349372687',
    learn_more: 'Zobrazit návod',
    learn_more_url: 'https://support.flux3dp.com/hc/en-us/articles/10273384373775',
    offset_x: 'Posun X',
    offset_y: 'Posun Y',
    pattern_size: 'Velikost vzoru',
    position_artwork: 'Umístěte dílo',
    position_step1: 'Upravte velikost a polohu svého díla na vzoru.',
    position_step2: 'Klikněte na „Použít“ pro použití automatického přizpůsobení na tento vzor.',
    preview_first: 'Nejprve proveďte náhled fotoaparátu.',
    reset_position: 'Obnovit pozici',
    retake: 'Znovu vyfotit',
    retake_tooltip: 'Znovu vyfotit na pozici každého objektu pro lepší detekci',
    retry_with_remove_bg: 'Odstranit pozadí',
    retry_with_remove_bg_tooltip: 'Odstranit pozadí z náhledového obrázku pro zlepšení detekce obrysů',
    rotation: 'Otočit',
    select_a_pattern: 'Vyberte vzor',
    selected_artwork: 'Vybrané dílo',
    step1: 'Vyberte vzor, na který chcete umístit dílo.',
    step2: 'Pokud nebyl nalezen žádný vzor, znovu náhled kamery a použijte funkci Automatické přizpůsobení.',
    step3: 'Pokud se stále nedaří najít správný vzor, ujistěte se, že váš předmět je jasně rozpoznatelný a pracovní plocha je čistá od nečistot.',
    title: 'Automatické přizpůsobení',
    use_original_image: 'Použít původní obrázek',
    use_original_image_tooltip: 'Obnovit původní náhledový obrázek bez odstranění pozadí',
    warning_bg_removal: 'Tato operace spustí funkci "Odstranit pozadí", která spotřebuje 0,02 Credit. Chcete pokračovat?',
    warning_retake_preview: 'Tato operace je částečné opětovné snímání. Budou přidány nové obrázky a pozadí. Chcete pokračovat?',
  },
  autosave: {
    open_settings: 'Otevřít nastavení',
    path_not_correct: 'Umístění automatického ukládání již neexistuje.',
    path_not_correct_desc: 'Prosím vyberte novou složku v <b>%(preferences)s > %(autosave)s > %(path)s</b> pro pokračování v ukládání vaší práce.',
  },
  barcode_generator: {
    bar_height: 'Výška čáry',
    bar_width: 'Šířka čáry',
    barcode: {
      invalid_value: 'Hodnota je neplatná pro vybraný formát.',
    },
    font: 'Písmo',
    font_size: 'Velikost písma',
    hide_text: 'Skrýt text',
    invert_color: 'Invertovat barvu',
    text: 'Text',
    text_margin: 'Okraj textu',
  },
  beambox: {
    ai_generate: {
      dimensions: {
        more: 'Více',
        ratio: 'Poměr',
        resolution: 'Rozlišení',
        title: 'Rozměry obrázku',
      },
      error: {
        config_description: 'Nepodařilo se načíst konfiguraci AI',
        config_message: 'Nepodařilo se načíst styly AI',
        generation_failed: 'Generování selhalo',
        import_failed: 'Import selhal',
        insufficient_credits: 'Nedostatek kreditů',
      },
      form: {
        count: 'Počet',
        credit_required: 'Požadované kredity',
        editor: 'Editor',
        generate: 'Generovat',
        laser_friendly: 'Vhodné pro laser',
      },
      header: {
        history_tooltip: 'Historie',
        reset_tooltip: 'Resetovat vše',
        title: 'AI tvorba',
      },
      history: {
        detail: 'Podrobnosti',
        empty_description: 'Zatím žádná historie generování. Začněte tvořit!',
        error_message: 'Nepodařilo se načíst historii',
        not_generated: '❌ Negenerováno',
        recreate: 'Znovu vytvořit',
        status_failed: 'Selhalo',
        status_generating: 'Generování',
        status_success: 'Úspěch',
        storage_notice: 'Ukládá se až 10 posledních záznamů. Vygenerované obrázky jsou uchovávány po dobu 3 dnů.',
        title: 'Historie generování',
      },
      loading: {
        history: 'Načítání historie...',
        styles: 'Načítání stylů AI...',
        tip_0: 'Spouštění kreativního enginu…',
        tip_1: 'Leštění pixelů… ✨',
        tip_2: 'Téměř hotovo, dolaďujeme detaily',
        tip_3: 'Stále pracujeme, tato část potřebuje trochu více času',
        tip_4: 'Velké nápady potřebují čas, děkujeme za trpělivost',
      },
      results: {
        download: 'Stáhnout',
        import: 'Importovat',
        title: 'Výsledky',
      },
      retry: 'Opakovat',
      style: {
        apply: 'Použít styl',
        choose: 'Vybrat styl',
        custom_creation: 'Vlastní tvorba',
        customize: 'Přizpůsobit',
        select: 'Vybrat styl tvorby',
      },
      upload: {
        add: 'Přidat',
        click_or_drag: 'Klikněte nebo přetáhněte obrázky sem',
        error: 'Chyba nahrávání',
        file_size_error: '%s: Velikost souboru musí být menší než %sMB',
        file_type_error: '%s: Jsou podporovány pouze obrázky JPEG, PNG a WebP',
        from_history: 'Z historie',
        images: 'Nahrát obrázky',
        max_images_error: 'Maximálně %s obrázků povoleno',
        selected: '%s / %s vybráno',
        supported_formats: 'JPEG, PNG, WebP • Max %s',
      },
      validation: {
        description_or_image_required: 'Zadejte popis nebo nahrajte alespoň jeden obrázek',
        field_exceeds_max_length: '„%s" překračuje maximální délku %s znaků.',
        field_required: '„%s" je povinné. Vyplňte prosím toto pole.',
        login_required: 'Pro použití AI generování se prosím přihlaste.',
        max_images: 'Maximálně %s obrázků povoleno',
      },
    },
    ai_upscale_panel: {
      credit_amount: '%s AI kreditů',
      credit_balance: 'Zůstatek AI kreditů',
      credit_cost: 'Použité AI kredity',
      description: 'Zvyšte rozlišení a detaily obrázku pomocí AI. Zvětšený obrázek nahradí originál na plátně.',
      done: 'Generativní zvětšení dokončeno',
      dpi_recommended: 'Doporučeno pro aktuální DPI vrstvy: %dx.',
      dpi_recommended_capped: 'Doporučeno pro aktuální DPI vrstvy: %dx, ale %dx je maximum v rámci doporučené výstupní velikosti.',
      failed: 'Generativní zvětšení se nepodařilo dokončit. Zkontrolujte síťové připojení a zkuste to znovu.',
      insufficient_credit: 'Nedostatek AI kreditů pro spuštění generativního zvětšení.',
      layer_dpi: 'DPI vrstvy',
      original_size: 'Původní velikost',
      output_size: 'Výstupní velikost',
      oversize_warning: 'Výstupní velikost (%s) překračuje doporučené maximum %dpx x %dpx. Zpracování může trvat několik minut a výsledek může zpomalit Beam Studio. Přesto pokračovat?',
      processing: 'Zvětšování…',
      processing_hint: 'Doba zpracování závisí na velikosti obrázku a stavu sítě.',
      recommended: 'Doporučeno',
      retry: 'Zkusit znovu',
      start: 'Spustit zvětšení',
    },
    announcement_panel: {
      title: 'Ohlášení',
    },
    banner: {
      auto_feeder: 'Režim Automatického Podavače',
      autofocus1: 'Režim automatického zaostřování',
      autofocus2: 'Klikněte kamkoli pro automatické zaostření.',
      camera_preview_borderless_mode: '(Otevřené Dno)',
      curve_engraving: 'Režim Gravírování na Křivkách',
      firmware_warning: {
        message: 'Zařízení %s používá firmware v%s, což může ovlivnit stabilitu systému. Doporučujeme aktualizovat na nejnovější verzi.',
        remindLater: 'Připomenout později',
        updateNow: 'Aktualizovat nyní',
      },
      pass_through: 'Režim Průchodu',
      rotary: 'Režim Otočný',
    },
    bottom_right_panel: {
      convert_text_to_path_before_export: 'Převést text na cestu...',
      export_file_error_ask_for_upload: 'Nepodařilo se exportovat úlohu. Jste ochotni při hlášení chyby poskytnout vývojářům pracovní oblast?',
      retreive_image_data: 'Získat data z obrázku...',
    },
    context_menu: {
      copy: 'Kopírovat',
      cut: 'Vyjmout',
      delete: 'Smazat',
      duplicate: 'Duplikovat',
      group: 'Sloučit do skupiny',
      move_back: 'Přenést dál',
      move_down: 'Přenést do pozadí',
      move_front: 'Přenést do popředí',
      move_up: 'Přenést blíž',
      paste: 'Vložit',
      paste_in_place: 'Vložit na místo',
      ungroup: 'Rozdělit skupinu',
    },
    document_panel: {
      add_on: 'Doplňky',
      auto_feeder: 'Automatický podavač',
      auto_feeder_url: 'https://support.flux3dp.com/hc/en-us/articles/11688230498575',
      auto_shrink: 'Automatické zmenšení',
      auto_shrink_tooltip: 'Platí pouze pro vrstvy s rozlišením 250 DPI nebo vyšším.',
      auto_shrink_url: 'https://support.flux3dp.com/hc/en-us/articles/12997377035919',
      borderless_mode: 'Otevřít spodní část',
      current_position: 'Aktuální pozice',
      disable: 'Zakázat',
      document_settings: 'Nastavení dokumentu',
      door_protect: 'Ochrana dveří',
      door_protect_desc: 'Dostupné pouze s Promark Safe+.',
      enable_autofocus: 'Autofokus',
      enable_diode: 'Diodový laser',
      enable_nozzle_refresh_area: 'Povolit oblast obnovení trysky',
      extend_y_area: 'Rozšířit oblast Y',
      frame_before_start: 'Nejprve rámec, pak provést',
      frame_before_start_url: 'https://support.flux3dp.com/hc/en-us/articles/11494925637135',
      job_origin: 'Nastavování vodítek',
      laser_source: 'Laserový zdroj',
      machine: 'Stroj',
      manual: 'Manuální',
      notification: {
        changeFromPrintingWorkareaTitle: 'Chcete převést Tiskové vrstvy na Laserové vrstvy?',
      },
      origin: 'Vodítka',
      pass_through: 'Průchod',
      pass_through_height_desc: 'Zadat délku objektu k rozšíření pracovní oblasti.',
      prespray_times: 'Počet pročištění',
      rotary_mode: 'Rotační',
      scale: 'Měřítko',
      skip_prespray: 'Přeskočit pročištění',
      start_from: 'Začít od',
      start_position: 'Počáteční pozice',
      start_work_button: 'Tlačítko Spustit',
      workarea: 'Pracovní oblast',
    },
    elements_panel: {
      animals: 'Zvíře',
      arrow: 'Šíp',
      avatar: 'Avatar',
      basic: 'Základní',
      birds: 'Pták',
      browse_categories: 'Procházet kategorie',
      celebration: 'Oslava',
      circular: 'Kruhový',
      cleaning_tools: 'Čisticí nástroje',
      CNY: 'Čínský Nový rok',
      corner: 'Roh',
      decor: 'Výzdoba',
      doctor: 'Lékař',
      easter: 'Velikonoce',
      elements: 'Prvky',
      environment: 'Prostředí',
      gardening_tools: 'Zahradní nástroje',
      graphics: 'Grafika',
      halloween: 'Halloween',
      hammer_wrench: 'Kladivo a klíč',
      heart: 'Srdce',
      holidays: 'Prázdniny',
      insect: 'Hmyz',
      kitchen_tools: 'Kuchyňské náčiní',
      label: 'Štítek',
      land: 'Země',
      line: 'Linka',
      load_more: 'Načíst dalších 100 výsledků',
      nature: 'Příroda',
      people: 'Lidé',
      photo: 'Fotka',
      plants: 'Rostlina',
      police: 'Policie',
      recently_used: 'Nedávno použité',
      ribbon: 'Stuha',
      sea: 'Moře',
      search_examples: 'Příklady:',
      search_invalid_characters: 'Byly použity neplatné znaky.',
      search_no_results: 'Pro "%s" nebyly nalezeny žádné výsledky. Zkontrolujte prosím pravopis nebo zkuste jiné klíčové slovo.',
      search_with_english: 'Povoleny jsou pouze anglické znaky, čísla, čárky a mezery.',
      shape: 'Tvar',
      sign_in: 'Přihlaste se a získejte více než 10 000 ikon zdarma',
      speech: 'Řeč',
      student: 'Student',
      study_tools: 'Studijní pomůcky',
      teacher: 'Učitel',
      text: 'Ohraničení textu',
      title: 'Prvky',
      tools: 'Nástroje',
      valentines: 'Valentýn',
      weather: 'Počasí',
      Xmas: 'Vánoce',
      zodiac: 'Zvěrokruh',
    },
    image_trace_panel: {
      back: 'Zpět',
      brightness: 'Jas',
      cancel: 'Storno',
      contrast: 'Kontrast',
      next: 'Další',
      okay: 'OK',
      threshold: 'Hranice',
      tuning: 'Parametry',
    },
    layer_color_config_panel: {
      add: 'Přidat',
      add_config: 'Přidat barvu',
      color: 'Barva',
      default: 'Obnovení výchozího nastavení',
      in_use: 'Tato barva se již využívá.',
      layer_color_config: 'Nastavení barev vrstev',
      no_input: 'Zadejte prosím platný hex kód barvy',
      power: 'Intenzita',
      repeat: 'Vykonate',
      speed: 'Rychlost',
      sure_to_delete: 'Určitě chcete smazat toto nastavení barev?',
      sure_to_reset: 'Přijdete o všechny přizpůsobené parametry. Opravdu chcete restartovat do původního nastavení?',
    },
    left_panel: {
      borderless_blind_area: 'Ne-gravírovací oblast',
      borderless_preview: 'Náhled kamery s otevřenou spodní částí',
      diode_blind_area: 'Doplněk hybridního laseru - slepá oblast',
      label: {
        adjust_height: 'Přizpůsobit výšku',
        array: 'Pole',
        boxgen: 'Boxgen',
        choose_camera: 'Kamera',
        clear_preview: 'Vyčistit náhled',
        cursor: 'Vybrat',
        curve_engraving: {
          clear_area: 'Vyčistit vybranou oblast',
          exit: 'Konec',
          preview_3d_curve: 'Náhled gravírování křivky',
          select_area: 'Vybrat oblast',
          title: 'Gravírování křivky',
        },
        elements: 'Prvky',
        end_preview: 'Konec náhledu',
        fit_text: 'Textové pole',
        line: 'Čára',
        live_feed: 'Živé vysílání',
        my_cloud: 'Můj cloud',
        oval: 'Ovál',
        pass_through: 'Průchod',
        pen: 'Propiska',
        photo: 'Obrázek',
        polygon: 'Polygon',
        preview: 'Náhled kamery',
        preview_precise: 'Přesný náhled kamery',
        preview_wide_angle: 'Náhled širokoúhlé kamery',
        qr_code: 'QR kód',
        rect: 'Obdélník',
        text: 'Text',
        trace: 'Obkreslit obrázek',
      },
      unpreviewable_area: 'Slepá oblast',
    },
    network_testing_panel: {
      average_response: 'Průměrná reakční doba',
      cannot_connect_1: '#840 Nepodařilo se připojit k cílové IP.',
      cannot_connect_2: '#840 Nepodařilo se připojit k cílové IP. Ujistěte se prosím, že je cíl ve stejné síti.',
      cannot_get_local: 'Nepodařilo se připojit k místní IP adrese.',
      connection_quality: 'Kvalita připojení',
      device_not_on_list: '#842 Přístroj není na seznamu, ale kvalita připojení je >70 a průměrná reakční doba je <100 ms.',
      empty_ip: '#818 Zadejte prosím nejdříve IP adresu cílového zařízení.',
      end: 'Ukončit',
      fail_to_start_network_test: '#817 Nepodařilo se zahájit testování sítě.',
      hint_connect_camera_timeout: 'Při zahajování náhledu kamery vyprší časový limit?',
      hint_connect_failed_when_sending_job: 'Nedaří se vám při odeslání úlohy připojit?',
      hint_device_often_on_list: 'Přístroj se často nenalézá na seznamu?',
      insert_ip: 'IP adresa cílového zařízení:',
      invalid_ip: '#818 Neplatná IP adresa',
      ip_startswith_169: '#843 IP adresa přístroje začíná 169.254',
      link_connect_camera_timeout: 'https://support.flux3dp.com/hc/en-us/articles/360001791895',
      link_connect_failed_when_sending_job: 'https://support.flux3dp.com/hc/en-us/articles/360001841656',
      link_device_often_on_list: 'https://support.flux3dp.com/hc/en-us/articles/360001841636',
      linux_permission_hint: 'Tato chyba se obvykle objevuje při nedostatku uživatelských práv.\nSpusťte prosím na terminálu "sudo beam-studio --no-sandbox", abyste získali práva a zahájili testování sítě.',
      local_ip: 'Místní IP adresa:',
      network_testing: 'Testování sítě',
      network_unhealthy: '#841 Kvalita připojení <70 nebo průměrná reakční doba >100 ms',
      start: 'Začít',
      test_completed: 'Test dokončen',
      test_fail: 'Test selhal',
      testing: 'Testuji síť...',
    },
    object_panels: {
      lock_desc: 'Zachovat poměr šířky a výšky (SHIFT)',
      text_to_path: {
        check_thumbnail_warning: 'Některé texty byly změněny na jiné fonty při rozebírání textů na cesty a některé znaky se nemusely správně převést.\nPřed odesláním úlohy prosím znovu zkontrolujte náhledový obrázek.',
        error_when_parsing_text: 'Chyba při převádění textu na cestu.',
        font_substitute_pop: 'Váš text obsahuje znaky, které nepodporuje současný font. <br/>Přejete si použít jako náhradu <strong>%s</strong>?',
        retry: 'Znovu prosím opakujte nebo vyberte jiný font',
        use_current_font: 'Použít současný font',
      },
      wait_for_parsing_font: 'Analyzuji font... Vyčkejte chvíli, prosím.',
    },
    path_preview: {
      current_position: 'Současná pozice',
      cut_distance: 'Vzdálenost řezu',
      cut_time: 'Snížit délku',
      end_preview: 'Ukončit náhled',
      estimated_time: 'Odhadovaná celková délka',
      invert: 'Převrátit',
      pause: 'Pauza',
      play: 'Přehrát',
      play_speed: 'Rychlost přehrávání',
      preview_info: 'Informace o náhledu',
      rapid_distance: 'Vzdálenost cesty',
      rapid_time: 'Putovní délka',
      remark: '* * Všechny poskytované hodnoty jsou pouze odhadem.',
      size: 'Velikost',
      start_here: 'Začít zde',
      stop: 'Zastavit',
      travel_path: 'Putovní cesta',
    },
    photo_edit_panel: {
      aspect_ratio: 'Poměr stran',
      brightness: 'Jas',
      brightness_and_contrast: 'Jas / Kontrast',
      circumference: 'Obvod',
      compare: 'Porovnat',
      contrast: 'Kontrast',
      crop: 'Oříznout',
      curve: 'Křivka',
      diameter: 'Průměr',
      free: 'Volné',
      invert: 'Převrátit barvy',
      original: 'Originál',
      phote_edit: 'Úprava fotky',
      processing: 'Zpracovávám',
      radius: 'Poloměr',
      rotary_warped: 'Otočně Zkřivené',
      rotary_warped_link: 'https://support.flux3dp.com/hc/en-us/articles/10828006201103',
      scale: 'Měřítko',
      sharpen: 'Zostřit',
      sharpness: 'Zaostření',
      start: 'Začít',
      warp: 'Zkřivit',
    },
    popup: {
      ai_credit: {
        buy_link: 'https://member.flux3dp.com/en-US/credit',
        insufficient_credit: 'Nedostatek kreditů',
        insufficient_credit_msg: 'Tato funkce vyžaduje %s AI kreditů, ale máte pouze %s AI kreditů.\nProsím zakupte další kredity a zkuste to znovu.',
        relogin_to_use: 'K použití této funkce se prosím znovu přihlaste.',
      },
      auto_feeder_origin: 'Použijte náhled rámování k ověření dráhy a oblasti laserové hlavy, poté upravte umístění materiálu nebo počáteční pozici gravírování podle výsledků, abyste předešli kolizím během procesu gravírování.',
      auto_switch_tab: {
        message: 'Do Předvoleb byla přidána nová možnost pro automatické přepínání mezi panelem Vrstvy a panelem Objekty. Tato možnost je ve výchozím nastavení vypnutá. Chcete nyní povolit automatické přepínání?<br/>Toto nastavení můžete kdykoli změnit v Předvolbách.',
        title: 'Automatické přepínání panelu vrstev a objektů',
      },
      backend_connect_failed_ask_to_upload: '#802 Objevují se chyby při snaze připojit se k backendu. Přejete si nahrát záznamy z hlášení o chybě?',
      backend_error_hint: 'Funkce nemusí správně pracovat kvůli chybě v backendu.',
      both_power_and_speed_too_high: 'Využívání laseru nízké intenzity prodlouží životnost laserové trubice.\nA příliš vysoká rychlost může u tohoto rozlišení vyústit v nízkou kvalitu gravírovaného stínování.',
      bug_report: 'Nahlášení chyby',
      change_workarea_before_preview: 'Pracovní oblast %s nesedí k momentálně nastavené pracovní oblasti. Chcete přepnout na momentální pracovní oblast?',
      convert_to_path_fail: 'Nepodařilo se převést na cestu.',
      disassemble_use: {
        clip_path_warning: 'Tento soubor obsahuje ořezovou masku a nelze jej rozložit.',
        execute_time_warning: 'Toto odstraní ze skupiny importované DXF nebo SVG. Protože může soubor obsahovat velký počet prvků, může rozdělování skupiny trvat. Opravdu si přejete pokračovat?',
      },
      dxf_bounding_box_size_over: 'Velikost kresby je mimo pracovní oblast. Přesuňte prosím svou kresbu blíž k vodítku ve vašem CAD softwaru, nebo se ujistěte, že je jednotka správně nastavena.',
      dxf_paste_failed: 'Nepodařilo se vložit DXF ze schránky. Ujistěte se, že zkopírovaný obsah je platný DXF.',
      dxf_version_waring: 'Verze tohoto DFX souboru není 2013, může dojít k problémům s kompatibilitou.',
      facebook_group_invitation: {
        already_joined: 'Už jsem členem',
        join_now: 'Jdu do toho',
        later: 'Možná později',
        message: 'Přidejte se k naší oficiální facebookové skupině, kde se propojíte s dalšími uživateli FLUX a kde můžete diskutovat o FLUX laserech, sdílet své laserové výtvory a být v obraze ohledně našich produktů. Těšíme se na vás!',
        title: 'Přidejte se k oficiální uživatelské skupině FLUX',
      },
      failed_to_load_svg: 'Nelze načíst data SVG',
      import_file_contain_invalid_path: '#808 Importovaný SVG soubor obsahuje nesprávnou cestu k obrázku. Ujistěte se prosím, že všechny soubory obrázků existují nebo do souboru vložte obrázek',
      import_file_error_ask_for_upload: 'Nepodařilo se importovat SVG soubor. Jste ochotní soubor poskytnout vývojářskému týmu pro nahlášení chyby?',
      import_svg: {
        advice_message: 'To může způsobit vážné zpomalení nebo selhání importu.',
        advice_message_2: 'Doporučujeme soubor před importem zjednodušit.',
        confirmation_message: 'Chcete pokračovat?',
        element_count_warning: 'Počet prvků: %s (Doporučeno: < %s).',
        file_size_warning: 'Velikost souboru: %sMB (Doporučeno: < %sMB).',
        intro_message: 'Soubor může být příliš velký nebo složitý:',
        path_d_command_count_warning: 'Počet příkazů: %s (Doporučeno: < %s).',
        title: 'Upozornění na import souboru',
      },
      layer_by_color: 'Barva',
      layer_by_layer: 'Vrstva',
      loading_image: 'Nahrávám obrázek, prosím vyčkejte...',
      more_than_two_object: 'Příliš mnoho objektů. Podpora pouze pro 2 objekty.',
      mouse: 'Myš',
      no_curve_engraving_with_modules: 'Tato úloha zahrnuje gravírování na zakřiveném povrchu, které nelze použít současně s barevným tiskem. Vypněte vrstvu barevného tisku a úlohu odešlete znovu.',
      no_support_text: 'Beam Studio v současnosti nepodporuje textové štítky. Převeďte prosím před importem text na cestu.',
      nolayer: 'Jedna vrstva',
      not_support_object_type: 'Nepodporovaný typ objektu.',
      or_turn_off_borderless_mode: ' Nebo vypněte mód otevřené spodní části.',
      path_engine_upgrade: {
        caption: 'K dispozici rychlejší generování úloh',
        keep_current: 'Zachovat současné',
        message: 'Vylepšili jsme výpočetní engine úloh pro zlepšení výkonu a zrychlení generování úloh.\nChcete přepnout na nový zrychlený engine?\nMůžete jej kdykoli vypnout v %(preferences)s > %(editor)s > %(path_acceleration)s.',
      },
      pdf2svg: {
        error_pdf2svg_not_found: '#825 Chyba: Příkaz pdf2svg nenalezen. Nainstalujte prosím pdf2svg se svým správcem balíčků (např.: "yum install pdf2svg" či "apt_get install pdf2svg").',
        error_when_converting_pdf: '#824 Chyba při převádění PDF na SVG:',
      },
      progress: {
        calculating: 'Vypočítávám',
        uploading: 'Nahrávám',
      },
      questionnaire: {
        caption: 'Pomozte nám vyplnit dotazník',
        message: 'Pomozte nám vyplnit dotazník, abychom mohli vylepšit Beam Studio',
        no_questionnaire_available: 'V současnosti není k dispozici žádný dotazník.',
        unable_to_get_url: 'Nepodařilo se získat odkaz k internetovému dotazníku. Potvrďte prosím své internetové připojení.',
      },
      reach_tab_count_limit: 'Bylo dosaženo limitu počtu karet',
      recommend_downgrade_software: 'Rozpoznali jsme starší verzi firmwaru. Aktivně adresujeme problémy s kompatibilitou, ale prozatím doporučujeme vrátit se k <a target="_blank" href="https://beamstudio.s3.ap-northeast-1.amazonaws.com/mac/Beam+Studio+1.9.5.dmg">Beam Studio 1.9.5</a>.',
      recommend_upgrade_firmware: 'Rozpoznali jsme starší verzi firmwaru. Aktivně adresujeme problémy s kompatibilitou, ale prozatím doporučujeme nainstalovat nejaktuálnější firmware.',
      save_unsave_changed: 'Přejete si uložit neuložené změny?',
      select_at_least_two: 'Pro pokračování vyberte dva objekty',
      select_first: 'Nejprve vyberte objekt.',
      select_import_method: 'Vyberte styl vrstvy:',
      select_import_module: 'Vyberte modul:',
      sentry: {
        message: 'Souhlasíte s tím, že pokud nastane chyba, budou se vývojářům automaticky nahrávat relevantní informace?',
        title: 'Pojďme společně vylepšit Beam Studio',
      },
      should_update_firmware_to_continue: '#814 Váš firmware nevyužívá tuto verzi Beam Studia. Pro pokračování prosím aktualizujte firmware. (Menu > Přístroj > [Váš přístroj] > Aktualizovat firmware)',
      speed_too_high_lower_the_quality: 'Využívání příliš vysoké rychlosti může u tohoto rozlišení vyústit v nízkou kvalitu gravírovaného stínování.',
      still_continue: 'Pokračovat',
      successfully_uploaded: 'Soubor byl úspěšně nahrán.',
      svg_1_1_waring: 'Verze tohoto SVG souboru je 1.1. Může dojít k problémům s kompatibilitou.',
      svg_image_path_waring: 'Tento SVG soubor obsahuje <image> načtený z cesty souboru. Můžou nastat chyby při načítání.\nAbyste se tomuto riziku vyhnuli, používejte prosím při exportování SVG vložený obrázek.',
      text_to_path: {
        caption: 'Konvertor textu na cestu 2.0',
        message: 'Beam Studio vám představuje nový konvertor textu na cestu (Converter 2.0), který přináší ještě spolehlivější výsledky!Přejete si na něho přepnout?\nSvoji volbu můžete později změnit ve vlastnostech v sekci Konvertor textu na cestu.',
      },
      too_fast_for_auto_feeder: 'Použití příliš vysoké rychlosti ve vrstvách obsahujících objekty cesty může vést ke snížení přesnosti při řezání.\nNedoporučujeme používat rychlost vyšší než %(limit)s při řezání s automatickým podavačem.',
      too_fast_for_auto_feeder_and_constrain: 'Následující vrstvy: %(layers)s \nobsahují vektorové cesty a jejich rychlost přesahuje %(limit)s.\nRychlost řezání vektorových cest s automatickým podavačem bude omezena na %(limit)s.\nTento limit můžete odstranit v nastavení předvoleb.',
      too_fast_for_curve: 'V režimu křivkového gravírování může být aktuální rychlost příliš vysoká a může ovlivnit detaily gravírování vrstev: %(layers)s.\nZvažte snížení rychlosti pro lepší kvalitu.',
      too_fast_for_path: 'Využívání příliš vysoké rychlosti u vrstev obsahující objekty cest může vyústit v nízkou přesnost při řezání.\nNedoporučujeme při řezání využívat rychlost vyšší než %(limit)s.',
      too_fast_for_path_and_constrain: 'Následující vrstvy: %(layers)s \nobsahují vektorové objekty cest a jejich rychlost převyšuje %(limit)s.\nRychlost řezání vektorových objektů cest bude omezena na %(limit)s.\nTento limit můžete odstranit v Nastavení.',
      touchpad: 'TouchPad',
      upload_failed: '#819 Nepodařilo se nahrát soubor.',
      upload_file_too_large: '#819 Soubor je pro nahrání příliš velký.',
      vectorize_shading_image: 'Obrázky s přechodem trvají delší dobu obkreslit a může dojít k zvýšenému hluku. Vypněte prosím obrázky s přechodem před zahájením.',
    },
    rating_panel: {
      description: 'Pokud se vám Beam Studio líbí, velice bychom ocenili, kdybyste nás ohodnotili.',
      thank_you: 'Děkujeme!',
      title: 'Užíváte si práci s Beam Studio?',
    },
    right_panel: {
      laser_panel: {
        advanced: 'Pokročilé',
        air_assist: 'Air Assist',
        am_density: 'Hustota rastrových bodů',
        backlash: 'Odpor',
        bi_directional: 'Obousměrný',
        by: 'Podle',
        ce_z_high_speed: 'Vysokorychlostní osa Z',
        ce_z_high_speed_link: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
        color_adjustment: 'Přizpůsobení kanálu',
        color_adjustment_short: 'Kanál',
        color_strength: 'Síla',
        cross_hatch: 'Křížové Stínování',
        custom_preset: 'Přizpůsobit',
        cut: 'Řezat',
        diode: 'Diodový laser',
        do_not_adjust_default_para: 'Předvolby nemůžou být upravovány.',
        dottingTime: 'Čas bodování',
        dropdown: {
          inches: {
            abs_engraving: 'ABS - gravírování',
            acrylic_3mm_cutting: 'Akryl - 1/8″ řez',
            acrylic_5mm_cutting: 'Akryl - 3/16″ řez',
            acrylic_7mm_cutting: 'Akryl - 1/4″ řez',
            acrylic_8mm_cutting: 'Akryl - 1/4″ řez',
            acrylic_10mm_cutting: 'Akryl - 3/8″ řez',
            acrylic_engraving: 'Akryl - gravírování',
            acrylic_printing: 'Akryl - tisk',
            aluminum_engraving: 'Hliník - gravírování',
            aluminum_light: 'Hliník (světlý)',
            bamboo_2mm_cutting: 'Bambus - 5/64″ řez',
            bamboo_5mm_cutting: 'Bambus - 3/16″ řez',
            bamboo_printing: 'Bambus - tisk',
            black_abs: 'Černý ABS',
            black_acrylic_3mm_cutting: 'Černý akryl - 1/8″ řez',
            black_acrylic_5mm_cutting: 'Černý akryl - 3/16″ řez',
            black_acrylic_engraving: 'Černý akryl - gravírování',
            brass_dark: 'Mosaz (tmavá)',
            brass_engraving: 'Mosaz - gravírování',
            brass_light: 'Mosaz (světlá)',
            canvas_fabric_printing: 'Plátno z látky - tisk',
            canvas_printing: 'Plátno - tisk',
            cardboard_printing: 'Lepenka - tisk',
            cardstock_printing: 'Karton - tisk',
            copper: 'Měď',
            cork_printing: 'Korek - tisk',
            denim_1mm_cutting: 'Džínovina - 1/32″ řez',
            fabric_3mm_cutting: 'Textilie - 1/8″ řez',
            fabric_5mm_cutting: 'Textilie - 3/16″ řez',
            fabric_engraving: 'Textilie - gravírování',
            fabric_printing: 'Textilie - tisk',
            flat_stone_printing: 'Plochý kámen - tisk',
            glass_bw_engraving: 'Sklo - gravírování',
            glass_printing: 'Sklo - tisk',
            gloss_leather_printing: 'Lesklá kůže - tisk',
            gold_engraving: 'Zlato - gravírování',
            iron_engraving: 'Železo - gravírování',
            leather_3mm_cutting: 'Kůže - 1/8″ řez',
            leather_5mm_cutting: 'Kůže - 3/16″ řez',
            leather_engraving: 'Kůže - gravírování',
            leather_printing: 'Kůže - tisk',
            mdf_3mm_cutting: 'Novozélandský MDF - 1/8″ řez',
            mdf_5mm_cutting: 'Novozélandský MDF - 3/16″ řez',
            mdf_7mm_cutting: 'Novozélandský MDF - 1/4″ řez',
            mdf_engraving: 'Novozélandský MDF - gravírování',
            mdf_printing: 'Novozélandský MDF - tisk',
            metal_bw_engraving: 'Kov - gravírování',
            opaque_acrylic: 'Neprůhledný akryl',
            pc_printing: 'Polykarbonát - tisk',
            rubber_bw_engraving: 'Guma - gravírování',
            silver_engraving: 'Stříbro - gravírování',
            slate_engraving: 'Břidlice - gravírování',
            stainless_steel_bw_engraving_diode: 'Nerezová ocel - gravírování (diodový laser)',
            stainless_steel_dark: 'Nerezová ocel (tmavá)',
            stainless_steel_engraving: 'Nerezová ocel - gravírování',
            stainless_steel_light: 'Nerezová ocel (světlá)',
            stainless_steel_printing: 'Nerezová ocel - tisk',
            steel_engraving_spray_engraving: 'Ocel - gravírování',
            sticker_kiss_cut: 'Samolepka – polovýsek',
            sticker_printing: 'Samolepka - tisk',
            stone: 'Kámen',
            ti_engraving: 'Titan - gravírování',
            titanium_dark: 'Titan (tmavý)',
            titanium_light: 'Titan (světlý)',
            white_abs: 'Bílý ABS',
            wood_3mm_cutting: 'Dřevo - 1/8″ řez',
            wood_5mm_cutting: 'Dřevo - 3/16″ řez',
            wood_7mm_cutting: 'Dřevo - 1/4″ řez',
            wood_8mm_cutting: 'Dřevo - 1/4″ řez',
            wood_10mm_cutting: 'Dřevo - 3/8″ řez',
            wood_engraving: 'Dřevo - gravírování',
            wood_printing: 'Dřevo - tisk',
          },
          mm: {
            abs_engraving: 'ABS - gravírování',
            acrylic_3mm_cutting: 'Akryl - 3mm řez',
            acrylic_5mm_cutting: 'Akryl - 5mm řez',
            acrylic_7mm_cutting: 'Akryl - 7mm řez',
            acrylic_8mm_cutting: 'Akryl - 8mm řez',
            acrylic_10mm_cutting: 'Akryl - 10mm řez',
            acrylic_engraving: 'Akryl - gravírování',
            acrylic_printing: 'Akryl - tisk',
            aluminum_engraving: 'Hliník - gravírování',
            aluminum_light: 'Hliník (světlý)',
            bamboo_2mm_cutting: 'Bambus - 2mm řez',
            bamboo_5mm_cutting: 'Bambus - 5mm řez',
            bamboo_printing: 'Bambus - tisk',
            black_abs: 'Černý ABS',
            black_acrylic_3mm_cutting: 'Černý akryl - 3mm řez',
            black_acrylic_5mm_cutting: 'Černý akryl - 5mm řez',
            black_acrylic_engraving: 'Černý akryl - gravírování',
            brass_dark: 'Mosaz (tmavá)',
            brass_engraving: 'Mosaz - gravírování',
            brass_light: 'Mosaz (světlá)',
            canvas_fabric_printing: 'Plátno z látky - tisk',
            canvas_printing: 'Plátno - tisk',
            cardboard_printing: 'Lepenka - tisk',
            cardstock_printing: 'Karton - tisk',
            copper: 'Měď',
            cork_printing: 'Korek - tisk',
            denim_1mm_cutting: 'Džínovina - 1mm řez',
            fabric_3mm_cutting: 'Textilie - 3mm řez',
            fabric_5mm_cutting: 'Textilie - 5mm řez',
            fabric_engraving: 'Textilie - gravírování',
            fabric_printing: 'Textilie - tisk',
            flat_stone_printing: 'Plochý kámen - tisk',
            glass_bw_engraving: 'Sklo - gravírování',
            glass_printing: 'Sklo - tisk',
            gloss_leather_printing: 'Lesklá kůže - tisk',
            gold_engraving: 'Zlato - gravírování',
            iron_engraving: 'Železo - gravírování',
            leather_3mm_cutting: 'Kůže - 3mm řez',
            leather_5mm_cutting: 'Kůže - 5mm řez',
            leather_engraving: 'Kůže - gravírování',
            leather_printing: 'Kůže - tisk',
            mdf_3mm_cutting: 'Novozélandská MDF - 3mm řez',
            mdf_5mm_cutting: 'Novozélandská MDF - 5mm řez',
            mdf_7mm_cutting: 'Novozélandská MDF - 7mm řez',
            mdf_engraving: 'Novozélandská MDF - gravírování',
            mdf_printing: 'Novozélandská MDF - tisk',
            metal_bw_engraving: 'Kov - gravírování',
            opaque_acrylic: 'Neprůhledný akryl',
            pc_printing: 'Polykarbonát - tisk',
            rubber_bw_engraving: 'Guma - gravírování',
            silver_engraving: 'Stříbro - gravírování',
            slate_engraving: 'Břidlice - gravírování',
            stainless_steel_bw_engraving_diode: 'Nerezová ocel - gravírování (diodový laser)',
            stainless_steel_dark: 'Nerezová ocel (tmavá)',
            stainless_steel_engraving: 'Nerezová ocel - gravírování',
            stainless_steel_light: 'Nerezová ocel (světlá)',
            stainless_steel_printing: 'Nerezová ocel - tisk',
            steel_engraving_spray_engraving: 'Ocel - gravírování',
            sticker_kiss_cut: 'Samolepka – polovýsek',
            sticker_printing: 'Samolepka - tisk',
            stone: 'Kámen',
            ti_engraving: 'Titan - gravírování',
            titanium_dark: 'Titan (tmavý)',
            titanium_light: 'Titan (světlý)',
            white_abs: 'Bílý ABS',
            wood_3mm_cutting: 'Dřevo - 3mm řez',
            wood_5mm_cutting: 'Dřevo - 5mm řez',
            wood_7mm_cutting: 'Dřevo - 7mm řez',
            wood_8mm_cutting: 'Dřevo - 8mm řez',
            wood_10mm_cutting: 'Dřevo - 10mm řez',
            wood_engraving: 'Dřevo - gravírování',
            wood_printing: 'Dřevo - tisk',
          },
          parameters: 'Předvolby',
          save: 'Přidat současné parametry',
        },
        engrave: 'Gravírovat',
        existing_name: 'Toto jméno je již používáno.',
        fill_angle: 'Úhel Vyplnění',
        fill_interval: 'Interval vyplnění',
        fill_setting: 'Nastavení Výplně',
        filled_path_only: 'Pouze pro vyplněné cesty',
        focus_adjustment: 'Přizpůsobení fokusu',
        frequency: 'Frekvence',
        gradient_only: 'Pouze pro gradientní obrázky',
        halftone: 'Půltón',
        halftone_link: 'https://support.flux3dp.com/hc/en-us/articles/9402670389647',
        height: 'Výška objektu',
        high_quality: 'Vysoká kvalita',
        high_quality_desc: 'Platí pouze pro vyplněné vektorové gravírování a obrázkové objekty. Povolení této možnosti sníží zrychlení gravírování pro jemnější výsledky.',
        ink_saturation: 'Saturace',
        low_air_assist_warning: 'Doporučuje se nastavit ofukování nad 50 %, aby se účinně snížilo riziko vznícení materiálu.',
        low_power_warning: 'Laser nízké intenzity (pod 10 %) nemusí vyslat laserové světlo.',
        low_speed_warning: 'Nízká rychlost může způsobit pálení materiálu.',
        lower_focus: 'Nižší zaostření',
        lower_focus_desc: 'Snížení výšky zaostření o určitou vzdálenost po zaostření pro zlepšení řezného výkonu.',
        module: 'Modul',
        more: 'Spravovat',
        multi_layer: 'Několik vrstev',
        para_in_use: 'Tento parametr je již používán.',
        parameters: 'Parametry',
        preset_management: {
          add_new: 'Přidat nový',
          delete: 'Smazat',
          export: 'Exportovat',
          export_preset_title: 'Exportovat předvolby',
          import: 'Importovat',
          laser: 'Laser',
          lower_focus_by: 'Snižte zaostření o',
          new_preset_name: 'Název nové převolby',
          preset: 'Předvolba',
          print: 'Vytisknout',
          reset: 'Restartovat',
          save_and_exit: 'Uložit a ukončit',
          show_all: 'Zobrazit vše',
          sure_to_import_presets: 'Přepíše vaše osobní nastavení a resetují se všechna tovární nastavení. Opravdu chcete pokračovat?',
          sure_to_reset: 'Odstraní se vaše osobní nastavení a resetují se všechny předvolby parametrů. Opravdu chcete pokračovat?',
          title: 'Spravovat parametry',
          wobble_diameter: 'Průměr vlnění',
          wobble_step: 'Velikost kroku vlnění',
        },
        preset_setting: 'Nastavení parametrů (%s)',
        presets: 'Předvolba',
        print_multipass: 'Multi-pass',
        promark_speed_desc: 'Parametr rychlosti není použitelný pro přechodové obrázky.',
        pulse_width: 'Šířka Pulzu',
        pwm_advanced_desc: 'Nastavte minimální výkon pro režim hloubky.',
        pwm_advanced_hint: 'Toto nastavení platí konkrétně pro obrázek s barevným přechodem při používání Depth Mode (režimu hloubky).',
        pwm_advanced_setting: 'Nastavení Depth Mode Power (výkonu režimu hloubky)',
        refresh_interval: 'Interval obnovení',
        refresh_printer: 'Obnovení tiskové hlavy',
        repeat: 'Přeskočit počítání',
        single_color: 'Jednobarevné',
        single_color_desc: 'Použitelné pouze pro plně barevnou vrstvu a nelze je použít s rozšířenou jednobarevnou vrstvou.',
        slider: {
          fast: 'Rychlé',
          high: 'Vysoké',
          low: 'Nízké',
          regular: 'Běžné',
          slow: 'Pomalé',
          very_fast: 'Nejrychlejší',
          very_high: 'Max',
          very_low: 'Min',
          very_slow: 'Nejpomalejší',
        },
        speed: 'Rychlost',
        speed_constrain_warning: 'Rychlost řezání objektů vektorových cest bude omezeno na %(limit)s. Toto omezení můžete odstranit v Nastavení.',
        speed_constrain_warning_auto_feeder: 'Rychlost řezání objektů Automatické podavače bude omezena na %(limit)s. Tento limit můžete odstranit v Nastavení preferencí.',
        speed_constrain_warning_curve_engraving: 'Rychlost gravírování křivkových objektů bude omezena na %(limit)s. Tento limit můžete odstranit v nastavení předvoleb.',
        speed_constrain_warning_module_addon: 'Při použití přídavného modulu se vyhněte rychlostem nad %(limit)s, abyste zachovali kvalitu gravírování.',
        stepwise_focusing: 'Postupné ostření',
        stepwise_focusing_desc: 'Postupné snižování zaostřovací vzdálenosti na základě výšky objektu během každého počítání průchodů.',
        strength: 'Intenzita',
        texture: 'Textura',
        texture_angle: 'Úhel',
        texture_intensity: 'Intenzita',
        texture_interval: 'Interval',
        texture_random: 'Náhodný',
        texture_stripe: 'Pruhy',
        times: 'krát',
        various_preset: 'Různé předvolby',
        white_ink: 'Bílý inkoust',
        white_ink_settings: 'Nastavení bílého inkoustu',
        wobble: 'Vlnění',
        wobble_desc: 'Vytvoří malé kruhy podél cesty, což je užitečné pro úlohy řezání. (Pouze pro objekty cesty.)',
        wobble_diameter: 'Průměr',
        wobble_step: 'Velikost kroku',
        z_step: 'Krok Z',
      },
      layer_panel: {
        current_layer: 'Současná vrstva',
        layer1: 'Vrstva 1',
        layer_bitmap: 'Bitmapa',
        layer_cutting: 'Řezání',
        layer_engraving: 'Gravírování',
        layers: {
          del: 'Smazat vrstvu',
          dupe: 'Duplikovat vrstvu',
          fullColor: 'Barevné',
          layer: 'Vrstva',
          layers: 'Vrstvy',
          lock: 'Uzamknout vrstvu',
          merge_all: 'Sloučit vše',
          merge_down: 'Sloučit dolů',
          merge_selected: 'Sloučit vybrané vrstvy',
          move_down: 'Přesunout vrstvu dolů',
          move_selected: 'Přesunout vybrané prvky do jiné vrstvy',
          move_up: 'Přesunout vrstvu nahoru',
          new: 'Nová vrstva',
          rename: 'Přejmenovat vrstvu',
          splitFullColor: 'Rozšířit vrstvu',
          switchToFullColor: 'Přepnout na barevnou vrstvu',
          switchToSingleColor: 'Přepnout na jednobarevnou vrstvu',
          unlock: 'Odemknout',
        },
        move_elems_to: 'Přesunout prvky do:',
        notification: {
          dupeLayerName: 'Tak už se nějaká vrstva jmenuje!',
          enterNewLayerName: 'Zadejte prosím nové jméno pro vrstvu',
          enterUniqueLayerName: 'Zadejte prosím unikátní jméno pro vrstvu',
          layerHasThatName: 'Tak už se vrstva jmenuje',
          mergeLaserLayerToPrintingLayerMsg: 'Pozor: Pokud tuto operaci dokončíte, nastavení laserové vrstvy bude odstraněno a přiřazeno podle současné vrstvy.',
          mergeLaserLayerToPrintingLayerTitle: 'Chcete spojit tyto vrstvy do jedné Tiskové vrstvy?',
          mergePrintingLayerToLaserLayerMsg: 'Pozor: Pokud tuto operaci dokončíte, nastavení barev tiskové vrstvy bude odstraněno a přiřazeno podle současné vrstvy.',
          mergePrintingLayerToLaserLayerTitle: 'Chcete tyto vrstvy spojit do jedné Laserové vrstvy?',
          moveElemFromPrintingLayerMsg: 'Pozor: Pokud tuto operaci dokončíte, nastavení barev vybraného prvku bude odstraněno a přiřazeno podle %s.',
          moveElemFromPrintingLayerTitle: 'Přesunout vybraný prvek do %s a převést ho na laserový prvek?',
          moveElemToPrintingLayerMsg: 'Pozor: Pokud tuto operaci dokončíte, nastavení vybraného prvku bude odstraněno a přiřazeno podle %s.',
          moveElemToPrintingLayerTitle: 'Přesunout vybraný prvek do %s a převést ho na tiskový prvek?',
          newName: 'NOVÉ JMÉNO',
          QmoveElemsToLayer: 'Přesunout vybrané prvky do vrstvy %s?',
          splitColorMsg: 'Pozor: Pokud budete s touto operací pokračovat, nebudete se moci vrátit k původním barevným vrstvám.',
          splitColorTitle: 'Přejete si rozšířit vybranou vrstvu do vrstev CMYK?',
        },
      },
      object_panel: {
        actions_panel: {
          ai_bg_removal: 'Odstranění pozadí',
          ai_bg_removal_short: 'Odstranění pozadí',
          ai_credit_reminder: 'Stisknutím tlačítka okamžitě zaplatíte %s kreditu. Přejete si pokračovat?',
          ai_upscale: 'Generativní zvětšení',
          ai_upscale_short: 'Zvětšení',
          ai_upscale_too_large: 'Tento obrázek je pro AI zvětšení příliš velký. Maximální podporovaná velikost je %dpx x %dpx.',
          array: 'Pole',
          auto_fit: 'Automaticky přizpůsobit',
          bevel: 'Zkosit',
          brightness: 'Jas',
          create_textpath: 'Vytvořit text na cestě',
          create_textpath_short: 'Text na cestě',
          crop: 'Oříznout',
          decompose_path: 'Rozložit',
          detach_path: 'Rozložit text na cestě',
          detach_path_short: 'Rozložit',
          disabled_by_gradient: 'Před použitím této funkce prosím vypněte přechod.',
          disabled_by_infilled: 'Před použitím této funkce zavřete výplň.',
          disabled_by_infilled_and_variable_text: 'Před použitím této funkce zavřete výplň a proměnný text.',
          disabled_by_noun_project: 'Tento tvar je chráněn právem duševního vlastnictví, proto jeho cestu nelze upravovat.',
          disabled_by_variable_text: 'Před použitím této funkce zavřete proměnný text.',
          disassemble_use: 'Rozebrat',
          disassembling: 'Rozebírám...',
          edit_path: 'Upravit cestu',
          fetching_web_font: 'Získávám online font...',
          grading: 'Přechod',
          invert: 'Převrátit',
          offset: 'Ofset',
          outline: 'Obrys',
          replace_with: 'Nahradit s...',
          replace_with_short: 'Nahradit',
          sharpen: 'Zaostřit',
          simplify: 'Zjednodušit',
          smart_nest: 'Smart Nest',
          to_image: 'Na obrázek',
          to_path: 'Na cestu',
          trace: 'Stopa',
          ungrouping: 'Rozděluji skupinu...',
          uploading_font_to_machine: 'Uploaduji font do přístroje...',
          wait_for_parsing_font: 'Analyzuji font... Počkejte prosím chvíli.',
          weld_text: 'Přivařit text',
        },
        align: 'Zarovnání',
        boolean: 'Boolean',
        bottom_align: 'Zarovnání dolů',
        center_align: 'Zarovnání na střed',
        difference: 'Rozdíl',
        distribute: 'Rozšířit',
        flip: 'Převrátit',
        group: 'Sloučit do skupiny',
        hdist: 'Horizontálně rozšířit',
        hflip: 'Převrátit horizontálně',
        intersect: 'Protnout',
        left_align: 'Zarovnání vlevo',
        lock_aspect: 'Uzamknout aspekt',
        middle_align: 'Zarovnání do středu',
        option_panel: {
          color: 'Barva',
          current_time: 'Aktuální čas',
          depth_engraving: 'Ražba',
          fill: 'Výplň',
          font_family: 'Font',
          font_size: 'Velikost',
          font_style: 'Styl',
          layer_count: 'Počet vrstev',
          letter_spacing: 'Mezery mezi písmeny',
          line_spacing: 'Řádkování',
          number: 'Pořadové číslo',
          offset: 'Posun',
          path_infill: 'Výplň cesty',
          pwm_engraving: 'Depth Mode (režim hloubky)',
          pwm_engraving_link: 'https://support.flux3dp.com/hc/en-us/articles/10419884701327',
          recently_used: 'Nedávno použité',
          rounded_corner: 'Zaoblený roh',
          shading: 'Barevný přechod',
          sides: 'Strany',
          start_offset: 'Ofset textu',
          stroke: 'Štětec',
          stroke_color: 'Barva štětce',
          stroke_width: 'Šířka štětce',
          text_align_center: 'Na střed',
          text_align_justify: 'Do bloku',
          text_align_left: 'Vlevo',
          text_align_right: 'Vpravo',
          text_content_placeholder: 'Zadejte text',
          text_infill: 'Výplň textu',
          threshold: 'Hranice jasu',
          threshold_short: 'Hranice',
          variable_text: 'Proměnný text',
          variable_text_link: 'https://support.flux3dp.com/hc/en-us/articles/12689396604175',
          vertical_align: 'Zarovnání',
          vertical_text: 'Vertikální text',
        },
        path_edit_panel: {
          connect: 'Připojit',
          delete: 'Smazat',
          disconnect: 'Odpojit',
          node_type: 'TYP UZLU',
          round: 'Zaoblený',
          sharp: 'Ostrý',
        },
        right_align: 'Zarovnání vpravo',
        subtract: 'Ubrat',
        top_align: 'Zarovnání nahoru',
        ungroup: 'Rozdělit skupinu',
        union: 'Spojení',
        unlock_aspect: 'Odemknout aspekt',
        vdist: 'Vertikálně rozšířit',
        vflip: 'Převrátit vertikálně',
        zoom: 'Zoom',
      },
      uv_print_block: {
        title: 'UV Tisk',
      },
    },
    svg_editor: {
      unable_to_fetch_clipboard_img: 'Nepodařilo se získat obrázek ze schránky',
      unnsupported_file_type: 'Tento typ souboru není přímo podporován. Převeďte prosím soubor na SVG či bitmapu.',
    },
    tag: {
      g: 'Skupina',
      image: 'Obrázek',
      text: 'Text',
      use: 'Import SVG',
    },
    tool_panels: {
      _nest: {
        end: 'Zavřít',
        no_element: 'Žádné prvky k uspořádání.',
        rotations: 'Možná rotace',
        spacing: 'Rozestupy',
        start_nest: 'Uspořádat',
        stop_nest: 'Zastavit',
      },
      _offset: {
        corner_type: 'Roh',
        direction: 'Směr ofsetu',
        dist: 'Vzdálenost ofsetu',
        expand: 'Rozbalit',
        fail_message: 'Nepodařil se ofset objektů.',
        inward: 'Dovnitř',
        not_support_message: 'Vybrané prvky obsahují nepodporované  SVG tagy\nObrázek, skupina, text a importovaný objekt.',
        outward: 'Ven',
        round: 'Zaoblený',
        sharp: 'Ostrý',
        shrink: 'Sbalit',
      },
      array_dimension: 'Dimenze pole',
      array_interval: 'Interval pole',
      cancel: 'Storno',
      columns: 'Sloupce.',
      confirm: 'Potvrdit',
      dx: 'X',
      dy: 'Y',
      grid_array: 'Vytvořit mřížkové pole',
      nest: 'Optimalizace uspořádání',
      offset: 'Ofset',
      rows: 'Řádky',
    },
    units: {
      mm: 'mm',
      walt: 'W',
    },
    zoom_block: {
      fit_to_window: 'Přizpůsobit oknu',
    },
  },
  boxgen: {
    add_option: 'Přidat možnost',
    basic_box: 'Základní box',
    beam_radius: 'Kompenzace řezné spáry',
    beam_radius_warning: 'Odstranit kompenzaci řezné spáry, když jsou okraje a spoje boxu krátké, aby se zajistilo správné sestavení boxu',
    cancel: 'Storno',
    coming_soon: 'Již brzy',
    continue_import: 'Pokračovat k Importu',
    control_tooltip: 'Levé tlačítko myši pro rotaci\nPosouvání pro zoom\nPravé tlačítko pro panorama',
    control_tooltip_touch: 'Táhněte pro rotaci\nŠpetka pro zoom\nDva prsty pro panorama',
    cover: 'Obal',
    customize: 'Přizpůsobit',
    depth: 'Hloubka',
    edge: 'Hrana',
    finger: 'Zakousnutí',
    finger_warning: 'Vnitřní strana výšky boxu musí být minimálně 6 mm (0,24 palce), aby byl kompatibilní se spojem Zakousnutí.',
    import: 'Importovat',
    inner: 'Vnitřní',
    joints: 'Spoj',
    max_dimension_tooltip: 'Maximální šířka je %s, maximální výška/hloubka je nastavena na %s.',
    merge: 'Sloučit',
    outer: 'Vnější',
    reset: 'Restartovat',
    tCount: 'Počet Téček',
    tCount_tooltip: 'Počet Téček se vztahuje ke kratší straně. Jejich počet na delší straně je vypočítán na základě její délky.',
    tDiameter: 'Průměr Téčka',
    text_label: 'Popis',
    thickness: 'Tloušťka',
    title: 'BOXGEN',
    tLength: 'Výška Téček',
    tSlot: 'Téčka',
    tSlot_warning: 'Výška strany boxu musí být minimálně 30 mm (1,18 palce), aby byl kompatibilní se spojování Téčky.',
    volume: 'Objem',
    workarea: 'Pracovní oblast',
    zoom: 'Zoom',
  },
  buttons: {
    back: 'Předchozí',
    back_to_beam_studio: 'Zpátky do Beam Studio',
    done: 'Hotovo',
    next: 'Další',
  },
  calibration: {
    ador_autofocus_focusing_block: 'Tři sekundy držte stisknutou ikonu AF na hlavní stránce přístroje a nechte sondu, ať se dotýká fokusního bloku.',
    ador_autofocus_material: 'Tři sekundy držte stisknutou ikonu AF na hlavní stránce přístroje a nechte sondu, ať se jemně dotýká materiálu.',
    align_4_0: 'Vlevo nahoře',
    align_4_1: 'Vpravo nahoře',
    align_4_2: 'Vlevo dole',
    align_4_3: 'Vpravo dole',
    align_8_0: 'Vnější vlevo nahoře',
    align_8_1: 'Vnější vpravo nahoře',
    align_8_2: 'Vnější vlevo dole',
    align_8_3: 'Vnější vpravo dole',
    align_8_4: 'Vnitřní vlevo nahoře',
    align_8_5: 'Vnitřní vpravo nahoře',
    align_8_6: 'Vnitřní vlevo dole',
    align_8_7: 'Vnitřní vpravo dole',
    align_bottom_left: 'Vlevo dole',
    align_bottom_right: 'Vpravo dole',
    align_red_cross_cut: 'Zarovnejte prosím prostředek červeného kříže s vyříznutým křížem.',
    align_red_cross_print: 'Zarovnejte prosím prostředek červeného kříže s vytisknutým křížem.',
    align_top_left: 'Vlevo nahoře',
    align_top_right: 'Vpravo nahoře',
    analyze_result_fail: 'Nepodařilo se analyzovat zachycený obrázek. <br/>Ujistěte se prosím, že:<br/>1. Zachycený obrázek je celý zakryt bílým papírem.<br/>2. Platforma se řádně fokusuje.',
    ask_for_skip_engraving_task: 'Přejete si přeskočit krok gravírování a fotit a kalibrovat přímo?',
    ask_for_skip_printing_task: 'Chcete přeskočit krok tisku a pak vyfotit a kalibrovat přímo?',
    at_focus_height: 'na výšce zaostření',
    at_lower_height: 'na nižší výšce',
    back: 'Zpět',
    beamo2_autofocus_material: 'Ručně přesuňte laserovou hlavu nad materiál a poté spusťte ostřicí sondu, aby se spustilo automatické zaostření.',
    calculating_camera_matrix: 'Vypočítávám matici kamery...',
    calculating_regression_parameters: 'Vypočítávám regresní parametry...',
    calibrate_camera_before_calibrate_modules: 'Nechte prosím znovu zkalibrovat kameru před kalibrací modulů.',
    calibrate_done: 'Kalibrace dokončena. Při přesném fokusu je lepší přesnost kamery.',
    calibrate_done_diode: 'Kalibrace dokončena. Ofset modulu laserové diody byl uložen.',
    calibrate_success_msg: 'Úspěšná kalibrace.<br/>Skóre kalibrace je %s (%.2f).',
    calibrating: 'Kalibruji...',
    calibrating_with_device_pictures: 'Kalibruji s obrázky zařízení...',
    camera_calibration: 'Kalibrace kamery ',
    camera_parameter_saved_successfully: 'Parametr kamery úspěšně uložen.',
    cancel: 'Storno',
    charuco_auto_focus: 'Přesuňte laserovou hlavu nad vzor a stiskněte <b>AF</b> pro automatické zaostření.',
    charuco_capture: 'Klikněte na „Další” pro zachycení vzoru',
    charuco_move_to_point_a: 'Přesuňte laserovou hlavu tak, aby červené světlo bylo zarovnáno se středem <b>bodu A</b>.',
    charuco_move_to_point_b: 'Přesuňte laserovou hlavu vodorovně tak, aby červené světlo bylo zarovnáno se středem <b>bodu B</b>.',
    charuco_place_charuco_horizontal: 'Umístěte kalibrační vzor vodorovně na <b>%s</b> pracovní plochy.',
    charuco_place_charuco_vertical: 'Umístěte kalibrační vzor svisle na <b>%s</b> pracovní plochy.',
    charuco_position_bottom_left: 'Vlevo Dole',
    charuco_position_bottom_right: 'Vpravo Dole',
    charuco_position_center: 'Střed',
    charuco_position_left: 'Vlevo',
    charuco_position_right: 'Vpravo',
    charuco_position_top_left: 'Vlevo Nahoře',
    charuco_position_top_right: 'Vpravo Nahoře',
    check_checkpoint_data: 'Data kontrolního bodu',
    check_device_pictures: 'Kontrola obrázků zařízení',
    check_pnp_desc: 'Ujistěte se, že červené značky jsou zarovnány s místy gravírování\nPokud ne, klikněte na „Zpět" pro úpravu.\nPokud je vše v pořádku, výborně! 🎉',
    checking_checkpoint: 'Kontroluji data kontrolního bodu...',
    checking_pictures: 'Kontroluji obrázky zařízení...',
    click_next: 'Klikněte na "Další"',
    click_next_to_take_picture: 'Klikněte na „Další" pro pořízení fotografie.',
    diode_calibration: 'Kalibrace modulu diodového laseru',
    do_engraving: 'Gravírovat',
    download_and_print_calibration_pattern: 'Stáhněte si prosím níže uvedený kalibrační vzor a vytiskněte jej na papír formátu A4 (nebo Letter).',
    download_calibration_pattern: 'Stáhnout Kalibrační Vzor',
    download_chessboard_file: 'Stáhnout soubor šachovnice',
    downloading_checkpoint: 'Stahuji data kontrolního bodu...',
    downloading_pictures: 'Stahuji obrázky...',
    drawing_calibration_image: 'Vykresluji kalibrační obrázek...',
    dx: 'X',
    dy: 'Y',
    elevate_and_cut: 'Zvednout a řezat',
    elevate_and_cut_step_1: 'Umístěte světlou dřevěnou desku velikosti A4 nebo obálky do pracovní oblasti pozvednuté na 20 mm.',
    elevate_and_cut_step_1_prism_lift: 'Použijte Ador Prism Lift o maximální délce 14 mm s  minimálně 6 mm širokou dřevěnou deskou.',
    failed_to_calibrate_camera: '#848 Nepodařilo se kalibrovat kameru. Kontaktujte prosím FLUX podporu.',
    failed_to_calibrate_chessboard: 'Kalibrace s obrázkem šachovnice se nezdařila.',
    failed_to_calibrate_with_pictures: '#848 Nepodařilo se kalibrovat s obrázky zařízení.',
    failed_to_detect_calibration_pattern: 'Nepodařilo se detekovat kalibrační vzor. Upravte expozici kamery nebo přemístěte kalibrační vzor a zkuste to znovu.',
    failed_to_download_pictures: '#848 Nepodařilo se stáhnout obrázky. Kontaktujte prosím FLUX podporu.',
    failed_to_move_laser_head: 'Nepodařilo se pohnout laserovou hlavou.',
    failed_to_parse_checkpoint: 'Nepodařilo se rozebrat data kontrolního bodu.',
    failed_to_save_calibration_results: '#849 Nepodařilo se uložit výsledky kalibrace, zkuste to prosím znovu. Pokud bude problém přetrvávat, kontaktujte prosím FLUX podporu.',
    failed_to_save_camera_parameter: 'Nepodařilo se uložit parametr kamery.',
    failed_to_solve_pnp: 'Nepodařilo se vyřešit pozici kamery.',
    finish: 'Hotovo',
    found_checkpoint: 'Ve vašem zařízení byla nalezena data kontrolního bodu. Přejete si je z kontrolního bodu obnovit?',
    getting_plane_height: 'Získávám výšku plochy...',
    hint_adjust_parameters: 'Použijte tyto parametry k přizpůsobení červeného čtverce',
    hint_red_square: 'Prosím zarovnejte vnější část červeného čtverce s ořízlým čtvercem.',
    material_4_a4_paper: 'Čtyři listy bílého papíru formátu A4 (nebo Letter).',
    material_a4_calibration_pattern: 'Kalibrační vzor formátu A4 (nebo Letter).',
    materials_required: 'Požadované materiály:',
    module_calibration_2w_ir: 'Kalibrace infračerveného modulu',
    module_calibration_printer: 'Kalibrace tiskového modulu',
    module_offset_settings: 'Nastavení odsazení',
    module_offset_settings_desc: 'Prosím, upravte hodnoty odsazení X a Y tak, aby byla skutečná pozice %s zarovnána s výstupem CO2 laseru.',
    module_offset_settings_save_failed: 'Nepodařilo se uložit nastavení odsazení.',
    moving_laser_head: 'Pohybuji laserovou hlavou...',
    moving_platform: 'Plošina se pohybuje...',
    next: 'Další',
    no_picture_found: '#852 Vaše zařízení nemá dostupné žádné nezpracované fotky ke kalibraci. Proveďte prosím „Kalibrace kamery (Pokročilé)".',
    perform_autofocus_bb2: 'Přejděte na ovládací panel zařízení a stiskněte tlačítko AF pro automatické zaostření.',
    perform_autofocus_bm2: 'Ručně posuňte laserovou hlavu nad materiál a poté spusťte zaostřovací sondu pro spuštění automatického zaostření.',
    please_do_camera_calibration_and_focus: {
      beambox: 'Při kalibrování modulu laserové diody je potřeba kamera.\nUjistěte se prosím, že byla kamera tohoto stroje zkalibrována.\nPoté prosím upravte platformu na ústřední bod (výška vypnutého akrylu)',
      beamo: 'Při kalibrování modulu laserové diody je potřeba kamera.\nUjistěte se prosím, že byla kamera tohoto stroje zkalibrována.\nPoté prosím upravte laserovou hlavici, aby se fokusovala na gravírovaný objekt (výška vypnutého akrylu)',
    },
    please_goto_editor_first: 'Před pokračováním dokončete nastavení',
    please_place_dark_colored_paper: 'Umístěte prosím A4 nebo tmavý dopisový papír doprostřed pracovní oblasti.',
    please_place_paper: 'Umístěte prosím A4 nebo bílý dopisový papír do levého horního rohu pracovní oblasti.',
    please_place_paper_center: 'Umístěte prosím A4 nebo bílý dopisový papír doprostřed pracovní oblasti.',
    please_refocus: {
      beambox: 'Přizpůsobte prosím platformu ke kontaktnímu místu (výška vypnutého akrylu)',
      beamo: 'Přizpůsobte prosím laserovou hadici, aby se nastavila na gravírovaný objekt (výška vypnutého akrylu)',
      beamo_af: 'Dvakrát prosím poklepejte na postranní tlačítko doplňku autofokus a nechte sondu, aby se jemně dotýkala materiálu.',
      hexa: 'Dvakrát klikněte na tlačítko přizpůsobení výšky, abyste zvedli nahoru voštinový stůl a sonda se dotýkala gravírovaného materiálu.',
    },
    preparing_to_take_picture: 'Připravuji se k vyfocení...',
    promark_help_link: 'https://support.flux3dp.com/hc/en-us/articles/11173605809295',
    put_charuco: 'Umístěte kalibrační vzor',
    put_charuco_1: 'Vytiskněte kalibrační vzor (A4/Letter).',
    put_charuco_2: 'Nalepte ji naplocho na pevnou desku.',
    put_charuco_3: 'Umístěte na střed a proveďte automatické zaostření.',
    put_charuco_bm2_1: 'Vytiskněte soubor kalibračního vzoru na papír formátu A4 (Letter).',
    put_charuco_bm2_2: 'Klikněte na „Další“ a postupujte podle pokynů pro umístění papíru.',
    put_charuco_promark_2: 'Ujistěte se, že je kalibrační papír jasně viditelný bez odlesků. Klikněte na "Další" pro pořízení fotografie.',
    put_charuco_promark_desc_1: 'Použijte kalibrační papír dodaný v krabici s příslušenstvím, nebo vytiskněte následující kalibrační vzor na papír velikosti A4 pro kalibraci kamery.',
    put_charuco_promark_desc_2: 'Umístěte kalibrační papír naplocho a na středu pracovní plochy.',
    put_chessboard_promark_1: 'Nastavte ohniskovou vzdálenost na vhodné zaostření pro objektiv s polem.',
    put_chessboard_promark_2: 'Ujistěte se, že je šachovnicový papír jasně viditelný bez oslnění. Klikněte na "Další" pro pořízení fotografie.',
    put_chessboard_promark_desc_1: 'Použijte šachovnicový papír dodaný v krabici s příslušenstvím, nebo vytiskněte následující šachovnicový vzor na papír velikosti A4 pro kalibraci kamery.',
    put_chessboard_promark_desc_2: 'Umístěte šachovnici naplocho a na středu pracovní plochy.',
    put_paper: 'Vložte papír',
    put_paper_bm2_1: 'Položte dva bílé papíry A4 plochě a upevněte je.',
    put_paper_bm2_2: 'Snižte sondu zaostření pro automatické zaostření na papír.',
    put_paper_bm2_3: 'Zavřete kryt dveří.',
    put_paper_bm2_4: 'Klikněte na "Začít Gravírovat".',
    put_paper_promark: 'Vložte černou lepenku',
    put_paper_promark_1: 'Položte černou lepenku z příslušenství na pracovní platformu.',
    put_paper_promark_2: 'Správně nastavte zaostření a poté klikněte na "Začít Gravírovat" pro pokračování.',
    put_paper_skip: 'Pokud kalibrační kresba automaticky nepokračuje k pořízení snímku, stiskněte „Přeskočit“ pro pořízení snímku.',
    put_paper_step1: 'Vložte prosím bílý papír formátu A4 nebo dopisu doprostřed pracovní oblasti.',
    put_paper_step2: 'Zajistěte čtyři rohy papíru, aby zůstal rovně položený.',
    put_paper_step3: 'Klikněte na "Začít Gravírovat"',
    put_paper_wide_angle_1: 'Položte čtyři bílé papíry formátu A4 nebo Letter tak, aby pokryly celou pracovní plochu.',
    put_paper_wide_angle_2: 'Upevněte papíry, aby ležely rovně.',
    relocate_camera: 'Přemístit kameru',
    relocate_camera_desc: 'Pokud jsou dveře otevřeny nebo je laserová hlava přesunuta, přemístěte kameru a znovu zarovnejte body.',
    res_average: 'Průměrné',
    res_excellent: 'Výborné',
    res_poor: 'Špatné',
    reset_points: 'Obnovit body',
    retake: 'Znovu vyfotit',
    rotation_angle: 'Rotace',
    show_last_config: 'Ukázat poslední výsledek',
    skip: 'Přeskočit',
    solve_pnp_bm2: 'Potvrďte, že na papírech je vyrytých 16 značek. (Pokud ne, klikněte na Zpět a znovu vyryjte.)',
    solve_pnp_keep_door_closed: 'Během následujícího procesu mějte dveře zavřené.',
    solve_pnp_move_platform: 'Stroj se automaticky posune dolů a pořídí další fotografii. Během tohoto procesu prosím nepohybujte kalibračním papírem.',
    solve_pnp_open_the_lid: 'Prosím, otevřete víko, abyste pořídili fotografii.',
    solve_pnp_step1: 'Zarovnejte prosím gravírovací body podle počtu a očekávané pozice všech červených značkovacích bodů.',
    solve_pnp_step2: 'Pro opětovné zarovnání můžete stisknout "Znovu vyfotit" nebo manuálně přizpůsobit pozice značky.',
    solve_pnp_step3: 'Pokud je bod gravírování viditelně mimo, přetáhněte zobrazení, dokud nebude bod viditelný, a klikněte na „Znovu vyfotit".',
    solve_pnp_title: 'Zarovnat značkovací body.',
    start_engrave: 'Začít Gravírovat',
    start_printing: 'Začít Tisk',
    step: 'Krok',
    taking_picture: 'Fotím...',
    title_align_marker_points: 'Zarovnat značkovací body',
    title_capture_calibration_pattern: 'Zachytit kalibrační vzor',
    title_confirm_calibration_result: 'Potvrdit výsledek kalibrace',
    title_engrave_marker_points: 'Vyrýt značkovací body',
    title_prepare_materials: 'Připravte materiály',
    unable_to_load_camera_parameters: "#851 Na vašem zařízení nejsou dostupné žádné parametry kalibrace kamery. Přejděte do 'Kalibrace' > 'Kalibrace kamery (Pokročilé)' a dokončete kalibraci pro získání parametrů.",
    update_firmware_msg1: 'Váš firmware nepodporuje tuto funkci. Pro pokračování prosím aktualizujte firmware na novější verzi',
    update_firmware_msg2: 'nebo vyšší (Menu > Přístroj > [Váš přístroj] > Aktualizovat firmware)',
    uploading_images: 'Nahrávám obrázky...',
    use_last_config: 'Použít hodnotu poslední kalibrace',
    use_old_camera_parameter: 'Přejete si použít současný parametr kamerových čoček?',
    with_af: 'S autofokusem.',
    with_prism_lift: 'S Ador Prism Lift',
    with_promark_safe_plus: 'S Promark Safe+',
    without_af: 'Bez autofokusu.',
    without_prism_lift: 'Bez Ador Prism Lift',
    without_promark_safe_plus: 'Bez Promark Safe+',
    x_ratio: 'Poměr X',
    y_ratio: 'Poměr Y',
    zendesk_link: 'https://support.flux3dp.com/hc/en-us/articles/360001811416',
  },
  camera_data_backup: {
    download_success: 'Data z kamery úspěšně stažena.',
    downloading_data: 'Stahuji data...',
    estimated_time_left: 'Zbývající délka:',
    folder_not_exists: 'Vybraná složka neexistuje.',
    incorrect_folder: 'Nepodařilo se nahrát kalibrační data. Zkontrolujte prosím, jestli byla vybrána správná složka.',
    no_picture_found: 'V přístroji nebyly nalezeny žádné obrázky.',
    title: 'Záloha dat z kamery',
    upload_success: 'Data z kamery úspěšně nahrána.',
    uploading_data: 'Nahrávám data...',
  },
  canvas_control: {
    calculate: 'Odhadnout délku',
    canvas_zoom: 'Zoom',
    exposure: 'Expozice',
    not_supported: 'Nepodporováno',
    opacity: 'Průhlednost',
  },
  caption: {
    connectionTimeout: 'Vypršel časový limit připojení',
  },
  change_logs: {
    added: 'Přidáno:',
    change_log: 'Záznamy o změnách:',
    changed: 'Změněno:',
    fixed: 'Opraveno:',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/sections/360000421876',
    see_older_version: 'Prohlédnout starší verze',
  },
  cloud_sync: {
    import_config: 'Byla nalezena cloudová nastavení pro toto zařízení. Chcete je importovat?',
    import_failed: 'Nepodařilo se přečíst cloudová nastavení.',
    sync_config: 'Chcete synchronizovat tato nastavení do cloudu?',
    sync_failed: 'Synchronizace nastavení do cloudu se nezdařila.',
    sync_success: 'Nastavení byla úspěšně synchronizována do cloudu.',
  },
  code_generator: {
    barcode: 'Čárový kód',
    content: 'Obsah',
    import: 'Importovat',
    qr_code: 'QR kód',
    type: 'Typ',
  },
  connection_issue_guide: {
    alert_link: 'Odpojuje se? Vyzkoušejte tento postup řešení potíží.',
    connect_computer: {
      content: 'Váš počítač musí být ve stejné síti jako zařízení.',
      macos_steps: 'Klikněte na ikonu Wi-Fi v řádku nabídek. Poté vyberte hotspot svého telefonu.',
      macos_title: 'macOS',
      title: 'Připojte svůj počítač',
      windows_steps: 'Klikněte na ikonu sítě na hlavním panelu. Poté vyberte hotspot svého telefonu.',
      windows_title: 'Windows',
    },
    connect_wifi: {
      cant_find_hotspot: 'Zařízení nemůže najít můj hotspot',
      dont_know_hotspot_name: 'Neznám název svého hotspotu',
      step1: '1. Na dotykovém panelu zařízení přejděte na: Síť → Připojit k Wi-Fi.',
      step2: '2. V seznamu Wi-Fi najděte a vyberte název hotspotu svého telefonu.',
      step3: '3. Zadejte heslo hotspotu a připojte se.',
      title: 'Připojte zařízení k hotspotu telefonu',
    },
    enter_ip: {
      check_firmware: 'Verze firmwaru',
      check_ip_reachable: 'IP je dostupná',
      check_machine_responds: 'Zařízení odpovídá',
      placeholder: 'IP adresa',
      step1: 'Zadejte IP adresu, kterou jste našli v předchozím kroku.',
      step2: 'Kliknutím na „Ověřit" otestujte připojení.',
      step3: 'Beam Studio zkontroluje:',
      title: 'Zadejte IP adresu svého zařízení',
      verify: 'Ověřit',
    },
    fail: {
      bullet1: '• Model a sériové číslo vašeho zařízení',
      bullet2: '• IP adresu zobrazenou na dotykovém panelu',
      bullet3: '• Popis chyby, na kterou jste narazili',
      contact_title: 'Při kontaktování podpory je užitečné mít po ruce:',
      intro: 'Nebojte se — nemusí to nutně znamenat, že je s vaším zařízením něco v nepořádku. Připojení mohou ovlivňovat další faktory. Náš tým podpory vám rád pomůže to vyřešit.',
      title: 'Test se nepodařilo dokončit',
    },
    hotspot: {
      android_steps: 'Nastavení → Připojení → Mobilní hotspot a sdílení připojení → Mobilní hotspot',
      android_title: 'Android',
      ios_steps: 'Nastavení → Osobní hotspot → Povolit ostatním připojení',
      ios_title: 'iPhone (iOS)',
      tip: 'Tip: Použijte jednoduchý anglický název hotspotu a číselné heslo (např. Název: FLUX_Test   Heslo: 12345678)',
      warning_2_4ghz: 'Důležité: Zařízení FLUX podporují pouze Wi-Fi 2.4GHz. Před pokračováním nastavte hotspot na 2.4GHz.',
    },
    how_it_works: 'Jak test funguje:',
    how_it_works_step1: '1. Nastavte svůj telefon jako hotspot Wi-Fi.',
    how_it_works_step2: '2. Připojte zařízení k hotspotu.',
    how_it_works_step3: '3. Připojte počítač ke stejnému hotspotu.',
    how_it_works_step4: '4. Otestujte připojení v Beam Studio.',
    intro: 'Provedeme rychlý test, abychom zkontrolovali, zda vaše zařízení funguje správně. Zařízení a počítač propojíme přes hotspot vašeho mobilního telefonu, abychom zjistili, zda je problém ve vaší síti, nebo v samotném zařízení.',
    ip_address: {
      step1: 'Na dotykovém panelu zařízení přejděte na:\nSíť → Vyhledejte „IP adresa"',
      step2: 'IP obvykle vypadá takto: 172.20.10.x nebo 192.168.x.x\n(Závisí to na hotspotu vašeho telefonu)',
      step3: 'Poznamenejte si tuto IP adresu pro další krok.',
      title: 'Najděte IP adresu svého zařízení',
      warning: 'Pokud IP začíná na 169.254, připojení selhalo. Vraťte se ke Kroku 1 a zkuste to znovu.',
    },
    success: {
      cause: 'Problém s připojením, který jste zaznamenali, je nejpravděpodobněji způsoben prostředím vaší místní sítě, nikoli samotným zařízením.',
      intro: 'Úspěšně jste dokončili test připojení Wi-Fi — skvělá práce! To potvrzuje, že vaše zařízení FLUX funguje bezvadně.',
      recommend1: '• Obraťte se na svého poskytovatele internetu (ISP) nebo výrobce routeru s žádostí o pomoc s nastavením Wi-Fi',
      recommend2: '• Zeptejte se správce sítě, pokud jste ve škole, kanceláři nebo sdíleném pracovním prostoru',
      recommend3: '• Zkontrolujte, zda váš router podporuje 2.4GHz, a zkuste jej restartovat',
      recommend_title: 'Co doporučujeme:',
      title: 'Skvělá práce! 🎉',
    },
    title: 'Problém s připojením?',
  },
  curve_engraving: {
    '921': 'Nepodařilo se automaticky zaostřit.',
    '922': 'Nepodařilo se provést měření červeným světlem.',
    amount: 'Množství',
    apply_arkwork: 'Použít umělecké dílo na křivku',
    apply_camera: 'Použít obraz z kamery na křivku',
    click_to_select_point: 'Klikněte pro vybrání nebo odznačení bodů pro opětovné měření.',
    coloumns: 'Sloupce',
    column_gap: 'Mezera mezi sloupci',
    err_object_over_range: 'Objekt překračuje rozsah měření.',
    failed_to_take_reference: 'Nepodařilo se získat referenci',
    gap: 'Mezera',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
    measure_audofocus_area: 'Změřit oblast autofokusu',
    preview_3d_curve: 'Náhled gravírování křivky',
    remeasure: 'Znovu změřit',
    remeasuring_points: 'Přeměřuji body...',
    reselect_area: 'Znovu vybrat oblast',
    row_gap: 'Mezera mezi řádky',
    rows: 'Řádky',
    set_object_height: 'Nastavit výšku objektu',
    set_object_height_desc: 'Změřit maximální tloušťku objektu.',
    start_autofocus: 'Zahájit autofokus',
    starting_measurement: 'Zahájit měření...',
    sure_to_delete: 'Chcete smazat zaostřovací data pro gravírování křivky?',
    take_reference: 'Vzít referenci',
    take_reference_desc: 'Prosím, přesuňte laserovou hlavu na nejvyšší bod objektu, spusťte zaostřovací sondu a klikněte na „Potvrdit“ pro zaostření.',
  },
  device: {
    abort: 'Zrušit',
    aborted: 'Zrušeno',
    aborting: 'Zrušeno',
    busy: 'Zaneprázdněn',
    cartridge_info_read_failed: 'Ujistěte se prosím, že je inkoust zcela vložen. Pokuste se inkoust vyjmout a znovu vložit.',
    cartridge_info_verification_failed: 'Ověřte prosím, že je váš inkoust FLUX autentický.',
    cartridge_serial_number: 'Sériové číslo inkoustové kazety',
    close_door_to_read_cartridge_info: 'K získání informací o inkoustu prosím zavřete dvířka přístroje.',
    completed: 'Dokončeno',
    completing: 'Dokončuji',
    deviceList: 'Seznam přístrojů',
    disable: 'Zakázat',
    disconnectedError: {
      caption: 'Přístroj odpojen',
      message: 'Potvrďte prosím, jestli je dostupný síťový přístup k %s',
    },
    firmware_version: 'Verze firmwaru',
    ink_color: 'Barva inkoustu',
    ink_level: 'Úroveň inkoustu',
    ink_type: 'Typ inkoustu',
    IP: 'IP',
    model_name: 'Jméno modelu',
    occupied: 'Zachovávám',
    pause: 'Pauza',
    paused: 'Pozastaveno',
    pausedFromError: 'Pozastaveno před chybou',
    pausing: 'Pozastavuji',
    please_wait: 'Prosím vyčkejte...',
    preparing: 'Připravuji',
    processing: 'Zpracovávám',
    quit: 'Konec',
    ready: 'Připraven',
    reconnecting: 'Znovu připojování',
    reset: 'Restart (Kop)',
    resuming: 'Obnovuji',
    retry: 'Opakovat',
    running: 'Pracuji',
    scanning: 'Skenuji',
    select: 'Vybrat',
    select_printer: 'Vyberte tiskárnu',
    serial_number: 'Sériové číslo',
    start: 'Začít',
    starting: 'Zahajuji',
    status: 'Stav',
    submodule_type: 'Modul',
    toolhead_change: 'Změnit hlavu nástroje',
    unknown: 'Neznámý',
    uploading: 'Nahrávám',
    UUID: 'UUID',
  },
  device_selection: {
    go_to_settings: 'Přejít Do Nastavení',
    macos_15_local_network_permission: 'V macOS 15 nebo novějším prosím povolte přístup Beam Studio k místní síti v Nastavení systému > Soukromí a zabezpečení > Místní síť.',
    no_device: '#801 Nemůžeme najít v síti váš přístroj.\n Podívejte se prosím do tohoto <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">návodu</a> pro řešení problému s připojením.',
    no_device_web: '#801  Zkontrolujte prosím stav vašeho přístroje nebo klikněte v dolní části na Nastavení přístroje k řádnému nastavení přístroje.',
    select_usb_device: 'Vyberte zařízení USB',
  },
  editor: {
    exposure: 'Jas',
    nozzle_refresh_area: 'Oblast Obnovení Trysky',
    opacity: 'Náhled průhlednosti',
    prespray_area: 'Primární oblast',
  },
  error_pages: {
    screen_size: 'Je možné, že Beam Studio nebude na vašem zařízení správně fungovat. Pro optimální zážitek by měla mít obrazovka minimální šířku 1024 pixelů.',
  },
  flux_id_login: {
    connection_fail: '#847 Nepodařilo se připojit k členské službě FLUX.',
    email: 'E-mail',
    flux_plus: {
      access_monotype_feature: 'Nemáte doplněk Monotype Fonts.',
      access_monotype_feature_note: 'Musíte být členem FLUX+ nebo mít doplněk Monotype Fonts, abyste měli přístup k této funkci.',
      access_plus_feature_1: 'Přihlašujete se k',
      access_plus_feature_2: 'funkci.',
      access_plus_feature_note: 'Musíte být členem FLUX+, abyste měli přístup k této funkci.',
      ai_credit_tooltip: 'Pro AI funkce',
      explore_plans: 'Prozkoumat nabídky FLUX+',
      features: {
        ai_bg_removal: 'Odstraňování pozadí',
        boxgen: '3D Box generátor',
        dmkt: '1000+ designových souborů',
        monotype: '250+ premium fontů',
        my_cloud: 'Neomezený úložný prostor v cloudu',
      },
      flux_credit_tooltip: 'Pro soubory z Design Market a AI odstraňování pozadí',
      get_addon: 'Získat doplněk',
      goto_member_center: 'Jít do Členského centra',
      learn_more: 'Zjistit víc',
      member_center_url: 'https://member.flux3dp.com/en-US/subscription',
      subscribe_now: 'Přihlásit se k odběru',
      thank_you: 'Děkujeme, že jste naším cenným členem!',
      website_url: 'https://flux3dp.com/subscription',
    },
    forget_password: 'Zapomenuté heslo?',
    incorrect: 'E-mailová adresa nebo heslo není správné.',
    login: 'Přihlásit se',
    login_success: 'Přihlášený',
    lost_password_url: 'https://id.flux3dp.com/user/forgot-password',
    new_to_flux: 'Začínáte s FLUX? Vytvořte si účet.',
    not_verified: 'E-mailová adresa zatím nebyla ověřena.',
    password: 'Heslo',
    register: 'Vytvořte si svůj FLUX účet',
    remember_me: 'Pamatuj si mě',
    sign_in_later: 'Přihlásit se později',
    signup_url: 'https://id.flux3dp.com/user/login#up',
    unlock_shape_library: 'Přihlaste se k odemčení databáze tvarů.',
  },
  framing: {
    area_check: 'Kontrola oblasti',
    areacheck_desc: 'Zajišťuje bezpečnost pracovní oblasti náhledem na ohraničující rámeček objektu a zónu akcelerace laserové hlavy.',
    calculating_task: 'Výpočet úlohy...',
    contour: 'Obrys',
    contour_desc: 'Náhled skutečného obrysu vzoru.',
    framing: 'Rámování',
    framing_desc: 'Náhled ohraničujícího rámečku objektu.',
    hull: 'Obrys',
    hull_desc: 'Zobrazuje tvar, který těsně kopíruje návrh, jako gumička obepínající objekt.',
    low_laser: 'Nízký laser',
    low_laser_desc: 'Nastavte hodnotu nízkého výkonu laseru pro úlohu rámování.',
    repeat: 'Opakovat',
    rotate_axis: 'Otočit osu',
    rotateaxis_desc: 'Náhled osy rotace, osa se nepohybuje.',
    rotation_frame_warning: 'Náhled rámečku se otočí o jednu otáčku. Nepřerušujte jej, aby nedošlo k posunutí polohy bodu.',
    rotation_framing_desc: 'Náhled celého rozsahu rotace, osa se pohybuje podle náhledu.',
    start_task: 'Spustit Úkol',
    start_task_description: 'Po dokončení náhledu rámce klikněte na „Spustit Úkol“ pro odeslání úlohy.',
  },
  general: {
    choose_folder: 'Vyberte složku',
    processing: 'Zpracovávám',
  },
  generators: {
    box_generator: 'Generátor boxů',
    code_generator: 'Generátor kódu',
    keychain_generator: 'Generátor přívěsků',
    material_test_generator: 'Generátor testování materiálu',
    puzzle_generator: 'Generátor puzzle',
    title: 'Generátory',
  },
  generic_error: {
    OPERATION_ERROR: '[OE] Nastal stavový konflikt, opakujte prosím akci.',
    SUBSYSTEM_ERROR: '[SE] Chyba při vykonávání úlohy strojového firmwaru. Restartujte prosím stroj.',
    UNKNOWN_COMMAND: '[UC] Aktualizujte prosím firmware zařízení.',
    UNKNOWN_ERROR: '[UE] Nastala neznámá chyba. Restartujte prosím Beam Studio a přístroj.',
  },
  global: {
    apply: 'Použít',
    back: 'Zpět',
    cancel: 'Zrušit',
    editing: {
      redo: 'Znovu',
      reset: 'Resetovat',
      reset_view: 'Obnovit Zobrazení',
      undo: 'Zpět',
      zoom_in: 'Přiblížit',
      zoom_out: 'Oddálit',
    },
    enable: 'Povolit',
    height: 'Výška',
    mode_conflict: 'Tato možnost není dostupná v aktuálním režimu.',
    ok: 'OK',
    preview: 'Náhled',
    save: 'Uložit',
    save_and_exit: 'Uložit a ukončit',
    saving: 'Ukládání...',
    select: 'Vybrat',
    stop: 'Zastavit',
    width: 'Šířka',
  },
  google_font_panel: {
    all_languages: 'Všechny jazyky',
    category: 'Kategorie',
    language_label: 'Jazyk',
    language_placeholder: 'Jazyk',
    language_unavailable_offline: 'Offline nedostupné',
    more_google_fonts: 'Více Google Fonts...',
    no_fonts_available: 'Nejsou dostupné žádné písma.',
    no_internet_connection: 'Žádné připojení k internetu',
    no_results_message: 'Nebyla nalezena žádná písma odpovídající vašim kritériím vyhledávání.',
    no_selection: 'Nebyl vybrán žádný font',
    offline_message: 'Google Fonts nejsou offline dostupné. Připojte se prosím k internetu pro procházení a výběr Google Fonts.',
    search_placeholder: 'Hledat písma...',
    search_unavailable_offline: 'Vyhledávání offline nedostupné',
    selected_prefix: 'Vybráno:',
    title: 'Google Fonts',
    unavailable_message: 'Google Fonts jsou momentálně nedostupné. Zkontrolujte prosím své internetové připojení nebo kontaktujte správce.',
  },
  image_edit_panel: {
    eraser: {
      brush_size: 'Velikost štětce',
      description: 'Klikněte nebo přetáhněte pro ruční vymazání nežádoucích oblastí.',
      title: 'Guma',
    },
    magic_wand: {
      description: 'Vyberte a odstraňte přilehlé oblasti na základě podobnosti barev.',
      title: 'Kouzelná hůlka',
      tolerance: 'Tolerance',
    },
    rounded_corner: {
      description: 'Upravte zaoblení rohů objektu.',
      radius: 'Poloměr',
      title: 'Zaoblený roh',
    },
    title: 'Upravit obrázek',
  },
  initialize: {
    back: 'Zpět',
    cancel: 'Zrušit',
    confirm: 'Potvrdit',
    connect: 'Připojit',
    connect_ethernet: {
      title: 'Přímé připojení',
      tutorial1: '1. Propojte přístroj a váš počítač síťovým kabelem.',
      tutorial2_1: '2. Postupujte ',
      tutorial2_2: ' abyste ze svého počítače udělali router.',
      tutorial2_a_href_mac: 'https://support.flux3dp.com/hc/en-us/articles/360001517076',
      tutorial2_a_href_win: 'https://support.flux3dp.com/hc/en-us/articles/360001507715',
      tutorial2_a_text: 'podle tohoto návodu',
      tutorial3: '3. Klikněte na Další.',
    },
    connect_machine_ip: {
      alert: {
        swiftray_connection_error: 'Nelze se připojit k serveru. Restartujte Beam Studio a zkuste to znovu.',
      },
      check_camera: 'Kontroluji dostupnost kamery',
      check_connection: 'Kontroluji připojení k přístroji',
      check_firmware: 'Kontroluji verzi firmwaru',
      check_ip: 'Kontroluji dostupnost IP.',
      check_swiftray_connection: 'Kontrola připojení k serveru',
      check_swiftray_connection_unreachable: 'server není dosažitelný',
      check_usb: 'Zkontrolujte USB připojení.',
      connection_failed_hint: 'Nelze se připojit ke stroji. Podívejte se na <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">tento návod</a> pro řešení problému.',
      enter_ip: 'Zadejte IP adresu svého přístroje.',
      finish_setting: 'Pojďme tvořit!',
      invalid_format: 'Špatný formát',
      invalid_ip: 'Špatné IP: ',
      promark_hint: 'Pokud se vám opakovaně nedaří připojit přes USB, podívejte se na <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/11318820440591">článek v Centru nápovědy</a>.',
      retry: 'Opakovat',
      starts_with_169254: 'Začíná 169.254',
      succeeded_message: 'Úspěšně připojeno 🎉',
      unreachable: 'Nedosažitelné IP',
      unreachable_macos_15: 'V systému macOS 15 nebo novějším povolte aplikaci Beam Studio přístup k místní síti v Nastavení systému > <a target="_blank" href="x-apple.systempreferences:com.apple.preference.security?Privacy_LocalNetwork">Soukromí a zabezpečení</a> > Místní síť.',
    },
    connect_usb: {
      connect_camera: 'Připojte kameru stroje k počítači pomocí USB kabelu.',
      title: 'USB připojení',
      title_sub: ' (Pouze HEXA & Ador)',
      turn_off_machine: 'Vypněte přístroj.',
      turn_on_machine: 'Zapněte přístroj.',
      tutorial1: 'Propojte USB kabelem svůj přístroj a počítač.',
      tutorial2: 'Klikněte na “Další”.',
      wait_for_turning_on: 'Klikněte na “Další”, až bude zahajovací proces hotový a uvidíte hlavní obrazovku.',
    },
    connect_wifi: {
      title: 'Připojuji se k Wi-Fi',
      tutorial1: '1.Na dotykovém panelu klikněte na "Síť" > "Připojit k Wi-Fi".',
      tutorial1_ador: '1. Na dotykovém panelu klikněte na "PŘÍSTROJ" > "Síť" > "Připojit k Wi-Fi".',
      tutorial2: '2. Zvolte svoji Wi-Fi a připojte se k ní.',
      what_if_1: 'Co když nevidím svou Wi-Fi?',
      what_if_1_content: '1. Šifrovací mód Wi-Fi by měl být WPA2 či bez hesla.\n2. Šifrovací mód může být nastaven v administrační části Wi-Fi routeru. Pokud router nepodporuje WPA2 a potřebujete pomoc se zvolením správného routeru, kontaktujte prosím podporu FLUX.\n3. Kanál Wi-Fi by měl být 2,4 GHz (5Ghz není podporován).',
      what_if_2: 'Co když nevidím žádnou Wi-Fi?',
      what_if_2_content: '1. Ujistěte se, že je Wi-Fi adaptér správně zapojený.\n2. Pokud se na dotykové obrazovce nenachází žádná MAC adresa bezdrátové sítě, kontaktujte prosím podporu FLUX.',
    },
    connect_wired: {
      title: 'Připojení pomocí síťového kabelu',
      tutorial1: '1. Připojte se svým routerem k přístroji.',
      tutorial2: '2. Stiskněte "Síť", abyste získali IP k drátové síti.',
      tutorial2_ador: '2. Stiskněte "PŘÍSTROJ" > "Síť", abyste získali IP drátové sítě.',
      what_if_1: 'Co když je IP prázdná?',
      what_if_1_content: '1. Ujistěte se, že je síťový kabel správně zapojený.\n2. Pokud není na dotykové obrazovce žádná MAC adresa drátové sítě, kontaktujte prosím podporu FLUX.',
      what_if_2: 'Co když IP začíná 169?',
      what_if_2_content: '1. Pokud IP adresa začíná 169.254, mělo by se jednat o problém s nastavením DHCP. Kontaktujte prosím svého poskytovatele internetu pro další pomoc.\n2. Pokud se váš počítač připojuje k internetu přímo s pomocí PPPoE, změňte prosím router, aby se připojoval pomocí PPPoE a aktivujte u routeru funkci DHCP.',
    },
    connecting: 'Připojuji...',
    connection_types: {
      ether2ether: 'Přímé připojení',
      usb: 'USB připojení',
      wifi: 'Wi-Fi',
      wired: 'Drátové připojení',
    },
    next: 'Další',
    no_machine: 'Nemám nyní přístroj.',
    promark: {
      configuration_confirmation: 'Tím zajistíte, že váš Promark bude správně nakonfigurován pro optimální efektivitu a přesnost.',
      or_complete_later: `Nebo přeskočte tento krok a dokončete nastavení Promark později na:
    Zařízení > „Název Promark“ > Nastavení Promark`,
      qc_instructions: 'Vyplňte parametry uvedené na zadní straně karty „QC Pass“',
      select_laser_source: 'Vyberte svůj Promark',
      select_workarea: 'Vyberte pracovní oblast',
      setting_completed_ask_camera_calibration: 'Nastavení objektivu s polem Promark bylo úspěšně dokončeno! Chcete pokračovat s kalibrací kamery?',
      settings: 'Nastavení Promark',
    },
    retry: 'Opakovat',
    select_beambox: 'Vyberte svůj Beambox',
    select_beamo: 'Vyberte svůj beamo',
    select_connection_type: 'Jak se přejete připojit?',
    select_hexa: 'Vyberte svůj HEXA',
    select_language: 'Vyberte jazyk',
    select_machine_type: 'Vyberte typ vašeho přístroje',
    select_promark: 'Vyberte svůj Promark',
    setting_completed: {
      back: 'Zpět',
      great: 'Vítejte v Beam Studio',
      ok: 'ZAČÍT TVOŘIT',
      setup_later: 'Vždy můžete svůj přístroj nastavit v záhlaví > "Přístroje" > "Nastavení přístroje"',
      start: 'Začít',
    },
    skip: 'Přeskočit',
    start: 'Spustit',
  },
  input_machine_password: {
    connect: 'PŘIPOJIT',
    password: 'Heslo',
    require_password: '"%s" vyžaduje heslo',
  },
  insecure_websocket: {
    extension_detected: 'Zjištěno rozšíření Beam Studio Connect.',
    extension_detected_description: 'Zjistili jsme, že bylo nainstalováno rozšíření Beam Studio Connect. Klikněte prosím na Potvrdit, abyste se přesměrovali na HTTPS, nebo klikněte na Storno, abyste nadále používali HTTP.',
    extension_not_deteced: 'Nepodařilo se najít rozšíření Beam Studio Connect.',
    extension_not_deteced_description: 'Pro použití HTTPS prosím klikněte na Potvrdit, čímž se nainstaluje rozšíření Beam Studio Connect. Po instalaci prosím obnovte stránku, aby se rozšíření aktivovalo.<br/>Nebo klikněte na odkaz dole, abyste zjistili, jak na Chrome používat HTTP.',
    unsecure_url_help_center_link: '<a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/9935859456271">Odkaz</a>',
  },
  keychain_generator: {
    decoration: 'Dekorace',
    design_preview: 'Náhled designu',
    element: 'Prvek',
    element_size: 'Velikost',
    emboss: 'Reliéf',
    exploded_view: 'Rozložený pohled',
    export_failed: 'Nepodařilo se importovat přívěsek na plátno. Zkuste to prosím znovu.',
    hole: 'Otvor',
    hole_options: {
      diameter: 'Průměr',
      hole_type: 'Typ',
      offset: 'Odsazení',
      position: 'Pozice',
      thickness: 'Tloušťka',
      type_punch: 'Průraz',
      type_ring: 'Kroužek',
    },
    import_to_canvas: 'Importovat na plátno',
    layers: {
      keychain: 'Přívěsek - Obrys',
      keychain_deco_emboss: 'Dekorace přívěsku - Řezání',
      keychain_deco_emboss_guide: 'Dekorace přívěsku - Řezací vodítko',
      keychain_deco_engraving: 'Dekorace přívěsku - Gravírování',
    },
    more_shapes: 'Více tvarů',
    outline_offset: 'Odsazení obrysu',
    reset_to_default: 'Obnovit výchozí',
    shape: 'Tvar',
    size_scale: 'Měřítko velikosti',
    switch_type_warning: 'Vaše aktuální nastavení ještě nebylo importováno na plátno.\nPřepnutí typu přívěsku obnoví všechna nastavení na výchozí hodnoty.',
    text: 'Text',
    text_options: {
      font_family: 'Rodina písem',
      font_settings: 'Nastavení písma',
      font_size: 'Velikost písma',
      font_style: 'Styl písma',
      letter_spacing: 'Mezery mezi písmeny',
      line_spacing: 'Řádkování',
      text_placeholder: 'Zadejte text...',
    },
    types: {
      animal: 'Zvířecí styl',
      capsule: 'Styl kapsle',
      dialog_box: 'Styl dialogového okna',
      geometry: 'Geometrický styl',
      oval: 'Oválný styl',
      pet: 'Styl mazlíčka',
      plant: 'Styl rostliny',
      polygonal: 'Mnohoúhelníkový styl',
      quadrilateral: 'Čtyřúhelníkový styl',
      round_arch: 'Styl kulatého oblouku',
      rounded: 'Zaoblený styl',
      surfing_board: 'Styl surfového prkna',
      tag: 'Styl štítku',
      text: 'Text',
      zodiac: 'Zvěrokruh',
    },
  },
  layer_module: {
    general_laser: 'Laser',
    laser_2w_infrared: '2W infračervený laser',
    laser_10w_diode: '10W diodový laser',
    laser_20w_diode: '20W diodový laser',
    non_working_area: 'Nepracovní oblast',
    none: 'Žádný',
    notification: {
      convertFromLaserModuleMsg: 'Pozor: Pokud tuto operaci dokončíte, nastavení laserové vrstvy bude odstraněno a nastaveno podle současné vrstvy.',
      convertFromLaserModuleTitle: 'Přejte si převést Laserový modul na Tiskový modul?',
      convertFromPrintingModuleMsg: 'Pozor: Pokud tuto operaci dokončíte, nastavení barev tiskové vrstvy bude odstraněno a nastaveno podle současné vrstvy.',
      convertFromPrintingModuleTitle: 'Přejte si převést Tiskový modul na Laserový modul?',
      importedDocumentContainsPrinting: 'Dokument obsahuje tiskovou vrstvu, přejete si změnit pracovní oblast na Ador?',
      importedDocumentContainsPrinting4C: 'Dokument obsahuje tiskovou vrstvu, přejete si změnit pracovní oblast na beamo II?',
      performIRCaliMsg: 'Klikněte na Potvrdit k provedení kalibrace, nebo vyberte kalibraci přes horní menu.<br />(Přístroj > [Jméno vašeho přístroje] > Kalibrovat infračervený modul)',
      performIRCaliTitle: 'Proveďte kalibraci infračerveného modulu',
      performPrintingCaliMsg: 'Klikněte na Potvrdit k provedení kalibrace, nebo vyberte kalibraci přes horní menu.<br />(Přístroj > [Jméno vašeho přístroje] > Kalibrovat tiskový modul)',
      performPrintingCaliTitle: 'Proveďte kalibraci tiskového modulu',
      printingLayersConverted: 'Tiskové vrstvy byly převedeny na laserové vrstvy.',
    },
    printing: 'Probíhá tisk',
    unknown: 'Neznámý modul',
    uv_print: 'UV Tisk',
    uv_varnish: 'Lak',
    uv_white_ink: 'Bílý inkoust',
  },
  machine_linking: {
    continue: 'Pokračovat',
    i_have_read: 'Přečetl/a jsem',
    input_birthday_to_link: 'Zadejte datum narození pro dokončení propojení zařízení',
    input_birthday_to_link_note: '*Slouží k ověření, zda váš věk splňuje požadavky na způsobilost',
    link_failed: 'Propojení se nezdařilo.',
    link_failed_already_linked: 'Toto zařízení je aktuálně propojeno s jiným FLUX ID. Můžete je dále používat nebo propojit se svým účtem.',
    link_failed_cannot_set_secret: 'Nelze uložit informace o propojení do zařízení. Zkontrolujte připojení mezi počítačem a zařízením.',
    link_failed_under_age: 'V současné době nesplňujete podmínky pro používání této služby a nemůžete dokončit propojení zařízení.',
    link_machine: 'Propojit FLUX ID',
    link_machine_to_account: 'Připojeno k %(name)s. Chcete toto zařízení propojit se svým účtem?',
    link_success: 'Propojení úspěšné.',
    link_to_my_flux_id: 'Propojit s mým FLUX ID',
    privacy_policy: 'Zásady ochrany osobních údajů',
    privacy_policy_link: 'https://flux3dp.com/privacy/',
    process_linking: 'Propojování…',
    use_without_linking: 'Použít bez propojení',
  },
  machine_status: {
    '-17': 'IO mód kazety',
    '-10': 'Udržovací mód',
    '-2': 'Skenuji',
    '-1': 'Udržuji',
    0: 'Nečinný',
    1: 'Zahajuji',
    2: 'ST_TRANSFORM',
    4: 'Zahajuji',
    6: 'Obnovuji',
    16: 'Pracuji',
    18: 'Obnovuji',
    32: 'Pozastaveno',
    36: 'Pozastaveno',
    38: 'Pozastavuji',
    48: 'Pozastaveno',
    50: 'Pozastavuji',
    64: 'Dokončeno',
    66: 'Dokončuji',
    68: 'Připravuji',
    128: 'Zrušeno',
    256: 'Alarm',
    512: 'Fatální',
    UNKNOWN: 'Neznámý',
  },
  maintenance: {
    actions: {
      checked: 'Zkontrolováno',
      done: 'Hotovo',
      fail: 'Neprošlo',
      history: 'Historie',
      open_guide: 'Otevřít návod',
      pass: 'Prošlo',
      print: 'Tisk / PDF',
    },
    areas: {
      back_cover: 'Zadní kryt',
      modules: 'Moduly',
      optics: 'Optika',
      panel: 'Panel',
      working_area: 'Pracovní oblast',
    },
    cadence: {
      by_material: 'Podle materiálu',
      condition: 'Podle stavu',
      day: 'Každý den',
      days: 'Jednou za %s dny',
      each_operation: 'Každé použití',
      every_1_2_weeks: 'Jednou za 1–2 týdny',
      month: 'Každý měsíc',
      months: 'Jednou za %s měsíce',
      upon_unboxing: 'Při prvním rozbalení',
      week: 'Každý týden',
      weeks: 'Jednou za %s týdny',
    },
    celebration: {
      subtitle: 'Váš přístroj %s je v perfektní kondici — jen tak dál.',
      title: 'Veškerá zásadní údržba je hotová!',
    },
    columns: {
      cadence: 'Frekvence',
      status: 'Stav',
      task: 'Úkol',
    },
    empty_no_machine: 'Připojte nebo vyberte přístroj, abyste zobrazili jeho plán údržby.',
    empty_no_schedule: 'Pro tento model zatím není k dispozici žádný kontrolní seznam údržby.',
    essential: 'Zásadní',
    essential_health: 'Stav zásadní údržby',
    essential_hint: 'započítává se do stavu',
    feedback: {
      checked: '%s zkontrolováno.',
      done: '%s je hotovo. Další termín %s.',
      done_no_date: '%s je hotovo.',
      fail_warning: '%s: označeno k výměně trubice. Postup najdete v návodu.',
      passed: '%s prošlo — trubice je v pořádku!',
    },
    footer_tip: 'Tip: Gravírujte každý měsíc vzorový soubor, abyste udrželi přístroj v dobré kondici.',
    history_hint: 'U každé úlohy se uchovává pouze %s posledních záznamů.',
    intro: 'Sledujte všechny úlohy údržby tohoto přístroje a označte je jako hotové jedním kliknutím.',
    legend: {
      due_soon: 'Brzy na řadě',
      overdue: 'Po termínu',
      up_to_date: 'Aktuální',
    },
    machine_groups: {
      my_machines: 'Moje přístroje',
      other_models: 'Ostatní modely',
    },
    machine_label: 'Přístroj',
    materials: {
      acrylic: 'Akryl',
      leather: 'Kůže',
      paper: 'Papír',
      wood: 'Dřevo',
    },
    status: {
      checked: 'Zkontrolováno',
      due: 'Termín',
      healthy: 'V pořádku',
      last: 'Naposledy hotovo',
      never_done: 'Nikdy neprovedeno',
      next: 'Příští termín',
      not_checked: 'Nezkontrolováno',
      not_logged: 'Nezaznamenáno',
      overdue: 'Po termínu',
      replace_tube: 'Vyměnit trubici',
    },
    tasks: {
      align: {
        keyPoints: 'Seřiďte, pokud je optická dráha rozladěná.',
        name: 'Seřízení optické dráhy',
      },
      chassis: {
        keyPoints: 'Odstraňte zbytky a dehtový olej ze skříně a spodního krytu.',
        name: 'Čištění skříně',
      },
      door: {
        keyPoints: 'Odstraňte mastnotu z krytu dvířek.',
        name: 'Čištění krytu dvířek',
      },
      exhaust: {
        keyPoints: 'Očistěte prach z lopatek ventilátoru.',
        name: 'Čištění odtahového ventilátoru',
      },
      fan: {
        keyPoints: 'Odstraňte prach z lopatek větracího ventilátoru.',
        name: 'Čištění větracího ventilátoru',
      },
      fieldlens: {
        keyPoints: 'Očistěte polní čočku, otírejte od středu ven ve směru hodinových ručiček.',
        name: 'Čištění polní čočky',
      },
      honeycomb_plate: {
        keyPoints: 'Odstraňte zbytky a dehet z mřížky voštinové desky.',
        name: 'Čištění voštinové desky',
      },
      honeycomb_table: {
        keyPoints: 'Odstraňte zbytky a dehtový olej z voštinové mřížky.',
        name: 'Čištění voštinového stolu',
      },
      lube: {
        keyPoints: 'Očistěte vodicí tyče, lineární kolejnici a zaostřovací mechanismus, poté je znovu namažte. Frekvence se liší podle řezaného materiálu.',
        name: 'Mazání',
      },
      maintain_test: {
        keyPoints: 'Zkontrolujte stavový displej a spínače.',
        name: 'Stránka MAINTAIN',
      },
      mirrors_combiner: {
        keyPoints: 'Odstraňte nečistoty z čoček a zrcadel; zkontrolujte oxidaci. Nenechávejte stopy po alkoholu ani vodě.',
        name: 'Zrcadla, fokusační čočka a slučovač paprsků',
      },
      mirrors_lens: {
        keyPoints: 'Očistěte 4 zrcadla a čočku; ujistěte se, že nejsou oxidované a nemají vodní skvrny.',
        name: 'Čištění zrcadel a čočky',
      },
      mod_diode: {
        keyPoints: 'Očistěte ventilátor, fokusační čočku a POGO pin.',
        name: 'Modul diodového laseru',
      },
      mod_ir: {
        keyPoints: 'Očistěte fokusační čočku.',
        name: 'Infračervený laserový modul',
      },
      optical_inspection: {
        keyPoints: 'Zkontrolujte optickou dráhu; také při rozbalení a po výměně trubice.',
        name: 'Kontrola optické dráhy',
      },
      optical_unboxing: {
        keyPoints: 'Ujistěte se, že je optická dráha přesná. Zkontrolujte při prvním rozbalení.',
        name: 'Kontrola optické dráhy',
      },
      screen: {
        keyPoints: 'Očistěte prach a mastnotu na panelu.',
        name: 'Čištění obrazovky',
      },
      tube: {
        keyPoints: 'Pokud nelze řezat 3mm akryl na 70% výkon, vyměňte trubici.',
        name: 'Kontrola stavu laserové trubice',
      },
      water: {
        keyPoints: 'Doplňte vodu na více než 80 % bez vzduchových bublin.',
        name: 'Výměna chladicí vody',
      },
      worktable: {
        keyPoints: 'Nastříkejte alkohol na ubrousek a poté otřete pracovní desku.',
        name: 'Čištění pracovní desky',
      },
      zaxis: {
        keyPoints: 'Otřete šroub sloupku osy Z a poté vatovou tyčinkou rovnoměrně naneste mazivo.',
        name: 'Mazání sloupku osy Z',
      },
    },
    title: 'Kontrolní seznam údržby',
  },
  material_test_generator: {
    block_settings: 'Nastavení bloků',
    columns: 'Sloupce',
    count: 'Počet',
    cut: 'Řez',
    engrave: 'Gravírování',
    export: 'Export',
    max: 'Max',
    min: 'Min',
    parameter: 'Parametr',
    rows: 'Řádky',
    size: 'Velikost (VxŠ)',
    spacing: 'Odstup',
    table_settings: 'Nastavení tabulky',
    text_settings: 'Nastavení textu',
    title: 'Generátor testování materiálu',
  },
  menu: {
    inches: 'palců',
    mm: 'mm',
  },
  message: {
    auth_error: '#820 Autorizační chyba: Aktualizujte prosím Beam Studio a firmware přístroje na nejnovější verzi.',
    authenticating: 'Ověřuji...',
    auto_focus: {
      instruction: 'Přesuňte prosím hlavici laserového modulu nad objekt a následujte instrukce k stisknutí AF pro fokus.',
      succeeded: 'Úspěšně zaostřeno',
      title: 'Autofokus',
      warning_at_coordinates: 'Po aktivaci režimu automatického zaostřování se laserová hlava resetuje a přesune na určenou pozici pro zaostření.\nUjistěte se, že cílová pozice je na materiálu a že v cestě pohybu nejsou žádné překážky.',
    },
    backend_calculation: {
      analyzing_svg: 'Analýza SVG - %d%% ...',
      calculating_task_path: 'Výpočet dráhy úlohy - %d%% ...',
      finishing: 'Dokončování...',
      initializing: 'Inicializace...',
    },
    camera: {
      abort_preview: 'Zrušit',
      calibration_data_missing: 'Nastavit kalibraci kamery',
      calibration_data_missing_message: 'Kalibrační data kamery chybí.\nImportujte uložená kalibrační data nebo proveďte kalibraci kamery.',
      calibration_wide_angle_camera_first: 'Nejprve prosím zkalibrujte širokoúhlou kameru.',
      camera_cable_unstable: 'Bylo zjištěno, že kamera nestabilně přenáší fotografie. Stále můžete spustit náhled, ale může nastat problém s pomalým náhledem či vypršením časového limitu.',
      continue_preview: 'Pokračovat',
      door_opened: 'Dveře otevřené',
      door_opened_text: 'Před opětovným spuštěním náhledu kamery prosím zavřete dveře.',
      fail_to_transmit_image: '#845 Něco se nepodařilo s přenosem obrázku.Restartujte prosím svůj přístroj nebo Beam Studio. Pokud bude tato chyba přetrvávat, přečtěte si prosím <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/4402756056079">tento návod</a>.',
      switching_camera: 'Přepínání kamery...',
      wide_angle_open_door: 'Otevřete dvířka',
      wide_angle_open_door_text: 'Před přepnutím na širokoúhlou kameru otevřete dvířka.',
      ws_closed_unexpectedly: '#844 Nečekaně bylo ukončeno spojení s kamerou přístroje. Pokud bude tato chyba přetrvávat, přečtěte si prosím <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/4402755805071">tento návod</a>.',
    },
    cancelling: 'Ruším...',
    cant_connect_to_device: '#827 Nepodařilo se připojit k přístroji, zkontrolujte prosím své připojení',
    connected: 'Připojeno',
    connecting: 'Připojuji...',
    connectingCamera: 'Připojuji kameru...',
    connectingMachine: 'Připojuji %s...',
    connectionTimeout: '#805 Vypršel časový limit připojení přístroje. Zkontrolujte prosím stav své sítě a indikátor Wi-Fi vašeho přístroje.',
    device_blocked: {
      caption: 'Neautorizované sériové číslo',
      offline: 'Sériové číslo vašeho zařízení je omezeno na offline použití, protože se zdá být deaktivováno. Poskytněte sériové číslo zařízení (umístěné na zadní straně zařízení) vašemu prodejci a požádejte jej, aby kontaktoval support@flux3dp.com k aktivaci online autorizace. Pokud chcete zařízení používat offline, kontaktujte přímo support@flux3dp.com.',
      online: 'Zdá se, že sériové číslo vašeho zařízení je deaktivováno. Poskytněte sériové číslo zařízení (umístěné na zadní straně zařízení) vašemu prodejci a požádejte jej, aby kontaktoval support@flux3dp.com k aktivaci autorizace zařízení.',
    },
    device_busy: {
      caption: 'Přístroj je zaneprázdněný',
      message: 'Přístroj vykonává jinou úlohu, zkuste to prosím později. Pokud přestane fungovat, restartujte prosím přístroj.',
    },
    device_is_used: 'Přístroj je momentálně využíván, chcete zrušit současnou úlohu?',
    device_not_found: {
      caption: 'Výchozí přístroj nenalezen',
      message: '#812 Zkontrolujte prosím indikátor Wi-Fi svého přístroje',
    },
    disconnected: 'Připojení nestále, zkontrolujte prosím nastavení zařízení a zkuste to později.',
    endingLineCheckMode: 'Ukončuji mód kontroly linek...',
    endingRawMode: 'Ukončuji režim ovládání stroje...',
    enteringLineCheckMode: 'Otevírám mód kontroly linek...',
    enteringRawMode: 'Vstupuji do režimu ovládání stroje...',
    enteringRedLaserMeasureMode: 'Vstup do režimu měření červeným laserem...',
    exitingRotaryMode: 'Ukončuji rotační mód...',
    getProbePosition: 'Získávám pozici sondy...',
    gettingLaserSpeed: 'Zjišťuji rychlost laserové hlavice...',
    homing: 'Navádím...',
    mac_os_arch_mismatch: {
      caption: 'Přeinstalovat kompatibilní verzi',
      download_center: 'Centrum stahování',
      message: 'Tento Mac používá Apple Silicon. Stáhněte verzi pro Apple Silicon a přeinstalujte.',
    },
    need_password: 'K připojení k přístroji je zapotřebí heslo',
    please_enter_dpi: 'Zadejte prosím jednotku svého souboru (v mm)',
    preview: {
      adjust: 'Přizpůsobit',
      adjust_height_tooltip: 'Použijte zaškrtávací políčko k povolení úprav.',
      already_performed_auto_focus: 'Již jste použili autofokus. Použít existující hodnoty?',
      camera_preview: 'Náhled kamery',
      capturing_image: 'Zachycování obrázku...',
      enter_manually: 'Vložit manuálně',
      getting_focal_distance: 'Získávání ohniskové vzdálenosti...',
      moving_to_preview_position: 'Přesouvání do náhledové pozice...',
      please_enter_height: 'Zadejte prosím výšku objektu, aby kamera zachytila přesný záběr.',
      please_focus_before_preview: 'Pro lepší kvalitu náhledu prosím proveďte automatické zaostření před náhledem.',
      press_esc_to_stop: 'Stisknutím ESC zastavíte náhled kamery.',
      succeeded: 'Úspěšně zobrazeno',
    },
    promark_disconnected: '#850 Připojení zařízení bylo přerušeno, zkontrolujte stav připojení zařízení.',
    redLaserTakingReference: 'Přijímání reference...',
    retrievingCameraOffset: 'Zjišťuji ofset kamery...',
    settingLaserSpeed: 'Nastavuji rychlost laserové hlavice...',
    swiftray_disconnected: 'Nelze se připojit k backendu, opakování připojení probíhá.',
    swiftray_reconnected: 'Backend byl znovu připojen, zkuste znovu odeslat úkol.',
    time_remaining: 'Zbývající čas:',
    tryingToConenctMachine: 'Pokouším se připojit k přístroji...',
    turningOffAirPump: 'Vypínám vzdušnou pumpičku...',
    turningOffFan: 'Vypínám větrák...',
    unable_to_find_machine: 'Nepodařilo se najít přístroj',
    unable_to_start: '#830 Nepodařilo se zahájit úlohu. Zkuste to prosím znovu. Pokud se to bude opakovat, nahlaste prosím chybu:\n',
    unavailableWorkarea: '#804 Současná pracovní oblast přesahuje pracovní oblast tohoto přístroje. Zkontrolujte prosím pracovní oblast vybraného přístroje nebo vyberte pracovní oblast z Upravit > Nastavení dokumentu.',
    unknown_device: '#826 Nepodařilo se připojit k přístroji. Ujistěte se prosím, že je USB připojen k přístroji.',
    unknown_error: '#821 Aplikace se setkala s neznámou chybou, využijte prosím Pomoc > Menu > Hlášení chyby.',
    unsupport_osx_version: 'Současná verze macOS %s nemusí podporovat některé funkce. Aktualizujte prosím na macOS 13+.',
    unsupport_win_version: 'Současná verze operačního systému %s nemusí podporovat některé funkce. Aktualizujte prosím na nejaktuálnější verzi.',
    unsupported_example_file: 'Vybraný ukázkový soubor není podporován současnou pracovní oblastí.',
    uploading_fcode: 'Nahrávám FCode.',
    usb_unplugged: 'USB připojení ztraceno. Zkontrolujte prosím připojení své USB.',
    wrong_swiftray_version_message: 'Verze backendu je chybná (verze: {version}). Zkontrolujte, zda neběží více instancí Beam Studio, a zavřete přebytečné instance před opakováním.',
    wrong_swiftray_version_title: 'Nesprávná verze backendu',
  },
  monitor: {
    ask_reconnect: 'Připojení k přístroji bylo narušeno. Přejete si znovu připojit?',
    bug_report: 'Hlášení chyby',
    camera: 'Kamera',
    cancel: 'Storno',
    confirmFileDelete: 'Určitě chcete tento soubor smazat?',
    connecting: 'Připojuji, prosím vyčkejte...',
    DEVICE_ERROR: 'Něco je v nepořádku\nRestartujte prosím přístroj', // Deprecated in FW 3.3.1
    download: 'Stáhnout',
    extensionNotSupported: 'Tento formát souboru není podporován',
    fileExistContinue: 'Soubor již existuje, přejete si ho nahradit?',
    forceStop: 'Přejete si zrušit současnou úlohu?',
    go: 'Začít',
    HARDWARE_ERROR_AIR_ASSIST_ABNORMAL: '#913 Anomálie senzoru proudění vzduchu',
    HARDWARE_ERROR_BOTTOM_OPENED: '#903 Spodní část otevřena. Pro pokračování prosím uzavřete spodní část.',
    HARDWARE_ERROR_CARTRIDGE_OVERHEAT: '#931 Upozornění na teplotu inkoustové cartridge\nTeplota inkoustové cartridge překračuje normální rozsah.\nPro ochranu byl úkol přerušen. Prosím znovu nainstalujte inkoustovou cartridge a restartujte úkol.',
    HARDWARE_ERROR_CARTRIDGE_POWERON_FAILED: '#930 Znovu nainstalujte inkoustovou cartridge\nByla zjištěna špatná přípojka inkoustové cartridge. Prosím znovu nainstalujte inkoustovou cartridge a zkuste to znovu.',
    HARDWARE_ERROR_COVER_NOT_CLOSED: '#924 Instalace krytu tiskové hlavy se nezdařila',
    HARDWARE_ERROR_COVER_NOT_OPENED: '#925 Odebrání krytu tiskové hlavy se nezdařilo',
    HARDWARE_ERROR_DOOR_OPENED: '#901 Pro pokračování prosím zavřete dvířka.',
    HARDWARE_ERROR_DRAWER_OPENED: '#911 Otevřená dvířka',
    HARDWARE_ERROR_FIRE_DETECTED: '#912 Anomálie senzoru plamene',
    HARDWARE_ERROR_HEADTYPE_MISMATCH: '#915 Nesprávný modul detekován. Pro pokračování prosím nainstalujte správný modul.',
    HARDWARE_ERROR_HEADTYPE_NONE: '#917 Modul nedetekován. Pro pokračování se prosím ujistěte, že je modul správně nainstalován.',
    HARDWARE_ERROR_HEADTYPE_UNKNOWN: '#918 Neznámý modul detekován. Pro pokračování prosím nainstalujte správný modul.',
    HARDWARE_ERROR_HOMING_PULLOFF_FAILED: '#920 Chyba Homing Pull-Off',
    HARDWARE_ERROR_KEY_OFF: '#929 Bezpečnostní klíč nebyl rozpoznán\nBezpečnostní klíč nebyl rozpoznán nebo byl deaktivován. Pro vaši bezpečnost nemůže stroj pracovat, dokud nebude klíč správně zapnut.\nProsím vložte bezpečnostní klíč a zapněte ho před obnovením práce.',
    HARDWARE_ERROR_LASER_TEMPERATURE_ABNORMAL: '#933 Abnormální teplota laseru\nTeplota laseru je příliš vysoká. Prosím zastavte provoz a nechte laser vychladnout před opětovným spuštěním.',
    HARDWARE_ERROR_LASER_VOLTAGE_ABNORMAL: '#932 Abnormální napětí laseru\nChyba napětí laseru. Prosím restartujte stroj. Pokud problém přetrvává, kontaktujte zákaznickou podporu.',
    HARDWARE_ERROR_LIMIT_SWITCH_TRIGGERED: '#934 Stroj zastaven — laserová hlava dosáhla limitu pracovní oblasti.',
    HARDWARE_ERROR_MAINBOARD_ERROR: '#401 Kritická chyba: Základní deska off-line. Kontaktujte prosím FLUX podporu.', // Deprecated in FW 3.3.1
    HARDWARE_ERROR_MAINBOARD_NO_RESPONSE: '#928 Základní deska neodpovídá\nZákladní deska neodpovídá. Prosím restartujte úlohu.',
    HARDWARE_ERROR_OVER_TEMPERATURE: '#902 Přehřátí. Vyčkejte prosím několik minut.',
    HARDWARE_ERROR_PLATFORM_HOMING_FAILED: '#910 Restart osy Z neúspěšný',
    HARDWARE_ERROR_PRINTER_NO_RESPONSE: '#919 Tiskový modul neodpovídá.',
    HARDWARE_ERROR_PROBE_SHOWED: 'Prosím, zatáhněte sondu.',
    HARDWARE_ERROR_PUMP_ERROR: '#900 Nízký průtok chladicí kapaliny. Zkontrolujte prosím nádržku s vodou.',
    HARDWARE_ERROR_REMOTE_INTERLOCK_OPENED: '#927 Vzdálený bezpečnostní spínač aktivován\nProsím zkontrolujte konektor vzdáleného bezpečnostního spínače a ujistěte se, že je bezpečně připojen, než obnovíte práci.',
    HARDWARE_ERROR_ROTARY_NOT_DETECTED: '#914 Nebyl identifikován rotační modul',
    HARDWARE_ERROR_SUBSYSTEM_ERROR: '#402 Kritická chyba: Subsystém neodpovídá. Kontaktujte prosím FLUX podporu.', // Deprecated in FW 3.3.1
    HARDWARE_FAILURE: 'Něco je v nepořádku\nRestartujte prosím přístroj', // Deprecated in FW 3.3.1
    hour: 'h',
    left: 'zbývá',
    MAINBOARD_OFFLINE: '#905 Chyba při připojování k základní desce.\nRestartujte prosím přístroj.',
    minute: 'm',
    monitor: 'MONITOR',
    NO_RESPONSE: '#905 Chyba při připojování k základní desce.\nRestartujte prosím přístroj.',
    no_task_info: 'Momentálně nejsou k zobrazení žádné úkoly.',
    pause: 'Pauza',
    prepareRelocate: 'Připravuji k přemístění',
    processing: 'Zpracovávám',
    record: 'Nahrát',
    relocate: 'Přemístit',
    RESOURCE_BUSY: 'Přístroj je zaneprázdněný.\nPokud nepracuje, přístroj prosím restartujte.',
    resume: 'Obnovit',
    savingPreview: 'Generuji miniatury',
    second: 's',
    start: 'Začít',
    stop: 'Zastavit',
    SUBSYSTEM_ERROR: '#402 Kritická chyba: Subsystém neodpovídá. Kontaktujte prosím FLUX podporu.',
    task: {
      BEAMBOX: 'Laserové gravírování',
      'N/A': 'Volný mód',
    },
    taskTab: 'Úloha',
    temperature: 'Teplota',
    upload: 'Nahrát',
    USER_OPERATION: 'Pro pokračování prosím následujte instrukce na panelu zařízení.',
    USER_OPERATION_CARTRIDGE_INK_EMPTY: 'Prázdná kazeta\nV kazetě došel inkoust. Vyměňte kazetu, abyste mohli pokračovat v tisku.',
    USER_OPERATION_CARTRIDGE_INK_LOW: 'Nízká hladina inkoustu\nInkoust v kazetě dochází. Doporučujeme kazetu brzy vyměnit.',
    USER_OPERATION_CHANGE_CARTRIDGE: 'Pro pokračování prosím vložte správnou kazetu.',
    USER_OPERATION_CHANGE_CARTRIDGE_CARTRIDGE_NOT_DETECTED: 'Pro pokračování prosím vložte kazetu.',
    USER_OPERATION_CHANGE_TOOLHEAD: 'Pro pokračování prosím nainstalujte správný modul.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_MISMATCH: '#915 Nesprávný modul detekován. Pro pokračování prosím nainstalujte správný modul.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_NONE: '#917 Modul nedetekován. Pro pokračování se prosím ujistěte, že je modul správně nainstalován.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_UNKNOWN: '#918 Neznámý modul detekován. Pro pokračování prosím nainstalujte správný modul.',
    USER_OPERATION_REMOVE_CARTRIDGE: 'Pro pokračování prosím odstraňte kazetu.',
    USER_OPERATION_ROTARY_PAUSE: 'Přepněte prosím na rotační motor.',
    USER_OPERATION_USER_Z_AXIS_CHECK_REQUIRED: 'Připomenutí zaostření\nPřed zahájením nové úlohy znovu zaostřete, abyste zajistili přesné výsledky.',
  },
  my_cloud: {
    action: {
      confirmFileDelete: 'Opravdu si přejete tento soubor smazat? Tato akce se nedá vrátit zpět.',
      delete: 'Smazat',
      download: 'Stáhnout',
      duplicate: 'Duplikovat',
      open: 'Otevřít',
      rename: 'Přejmenovat',
    },
    file_limit: 'Soubor zdarma',
    loading_file: 'Načítám...',
    no_file_subtitle: 'Klikněte na Menu > "Soubor" > "Uložit do cloudu"',
    no_file_title: 'Pro zahájení uložte soubory do Mého cloudu',
    not_login_title: 'Přihlaste se k uložení souborů do cloudu.',
    save_file: {
      choose_action: 'Uložit soubor:',
      input_file_name: 'Vložit název souboru:',
      invalid_char: 'Neplatné znaky:',
      save: 'Uložit',
      save_new: 'Uložit jako nový soubor',
      storage_limit_exceeded: 'Úložný prostor vašeho cloudu dosáhl maximální kapacity. Před uložením nových souborů prosím smažte nepotřebné soubory.',
    },
    sort: {
      a_to_z: 'Jméno: A - Z',
      most_recent: 'Nejnovější',
      oldest: 'Nejstarší',
      z_to_a: 'Jméno: Z - A',
    },
    title: 'Můj cloud',
    upgrade: 'Upgrade',
  },
  noun_project_panel: {
    clear: 'Vyčistit',
    elements: 'Prvky',
    enjoy_shape_library: 'Užijte si databázi tvarů.',
    export_svg_title: 'Nelze exportovat SVG',
    export_svg_warning: 'Tento projekt obsahuje objekty, které jsou chráněny právem duševního vlastnictví. Beam Studio proto během exportu automaticky vyjme tyto objekty. Stále si můžete uložit svůj projekt v Beam Studio Scene (ve formátu .beam), abyste si zachovali veškerá data. Stále si přejete exportovat?',
    learn_more: 'Zjistit víc',
    login_first: 'Přihlaste se k odemčení databáze tvarů.',
    recent: 'Nedávné',
    search: 'Hledat',
    shapes: 'Tvary',
  },
  params_label: {
    check_all: 'Vybrat vše',
    layer_name: 'Název vrstvy',
    placeholder: 'Štítek parametrů',
    preview_hint: 'Toto je náhled. Obsah textu se automaticky aktualizuje před odesláním úlohy',
    save_as_default: 'Uložit jako výchozí',
    settings: 'Nastavení štítku parametrů',
    update: 'Aktualizovat',
    updated: 'Štítek parametrů byl aktualizován',
    use_default: 'Použít uložené výchozí',
    use_recommended: 'Použít doporučené',
  },
  pass_through: {
    export: 'Export do pracovní oblasti',
    exporting: 'Exportuji...',
    guide_mark: 'Vodicí značka',
    guide_mark_desc: 'Vodicí značky budou gravírovány jako referenční bod pro zarovnání kresby.',
    guide_mark_length: 'Délka:',
    guide_mark_x: 'Souřadnice X:',
    height_desc: 'Nastavit výšku všech sekcí pracovní oblasti.',
    help_links: {
      ado1: 'https://support.flux3dp.com/hc/en-us/articles/10140002160399',
      fbb2: 'https://support.flux3dp.com/hc/en-us/articles/11570021253263',
    },
    help_text: 'Jak nastavit průchod pro %(model)s?',
    object_length: 'Délka objektu',
    ref_layer: 'Referenční vrstva',
    ref_layer_desc: 'Pozor: Výchozí hodnota referenční vrstvy je 0. Tato hodnota nebude použita, slouží pouze jako reference pro zarovnání.',
    ref_layer_name: 'Reference',
    title: 'Režim průchodu',
    workarea_height: 'Pracovní oblast (Výška):',
  },
  print_and_cut: {
    align_progress: {
      calculating: 'Výpočet…',
      capturing: 'Snímání obrazu',
      completing: 'Brzy dokončeno',
      detecting: 'Rozpoznávání zarovnávacích značek',
      locating: 'Hledání zarovnávacích značek',
      preparing: 'Příprava kamery',
      refining: 'Upřesňování polohy značek',
    },
    alignment: {
      detect_failed: 'Nebyl rozpoznán dostatečný počet zarovnávacích značek. Zopakujte prosím náhled kamery a zkuste to znovu.',
      fit_error: 'Chyba lícování (X / Y)',
      no_preview: 'Nebyl nalezen žádný snímek z náhledu kamery. Nejprve prosím spusťte náhled kamery a nasnímejte potištěný materiál.',
      rotation: 'Otočení',
      scale: 'Měřítko',
      success: 'Zarovnání dokončeno!',
    },
    backend_outdated: 'Aktuální firmware zařízení zatím nepodporuje funkci Print & Cut.',
    calibration: {
      align_desc: '1. Umístěte vytištěný kalibrační list do pracovní oblasti, přilepte ho páskou nebo maskovací páskou, aby se neposunul, a zaostřete.\n2. Klikněte na „Náhled a zarovnání“ pro spuštění zarovnání kamerou.\n3. Po nalezení značek klikněte na „Vyrýt stupnice“, čímž se na list nízkým výkonem vyryjí referenční čáry.',
      aligned: 'Zarovnávací značky nalezeny. Připraveno k rytí.',
      auto_read: 'Přečíst stupnice kamerou',
      auto_read_failed: 'Stupnice se nepodařilo přečíst automaticky. Odečtěte je okem a zadejte hodnoty.',
      auto_read_hint: 'Odečet kamerou se může lišit až o ±2; zkontrolujte jej podle listu.',
      current_offset: 'Aktuální posun: X %s mm, Y %s mm',
      export_pdf: 'Exportovat kalibrační PDF',
      power: 'Výkon',
      print_desc: '1. Exportujte PDF kalibračního listu. Obsahuje čtyři zarovnávací značky a dvě stupnice.\n2. Vytiskněte list v měřítku 100 % (skutečná velikost).',
      reading_desc: '1. Najděte nejdelší vyrytou čáru (prostřední) a všimněte si, na které straně tištěné čáry 0 leží.\n2. Postupujte čáru po čáře tímto směrem, dokud vyrytá čára přesně nelícuje s tištěnou čárou.\n3. Spočítejte od 0 k této tištěné čáře (čísla jsou vytištěna u každé 5. čáry; nečíslované čáry mezi nimi počítejte také).',
      reading_x: 'Odečet X',
      reading_y: 'Odečet Y',
      scratch: 'Vyrýt stupnice',
      speed: 'Rychlost',
      title: 'Kalibrace Tisk a řez',
    },
    continue_to_alignment: 'Pokračovat k zarovnání',
    cutting_layer_name: 'Tisk a řez - Řezání',
    design_changed: 'Návrh byl od tisku změněn, proto se zobrazuje pouze řezací dráha.\nPokračujte pro zarovnání dříve potištěného materiálu, nebo začněte znovu a připravte aktuální návrh.',
    export_pdf: 'Exportovat PDF',
    finish: 'Dokončit',
    fit_content: 'Přizpůsobit obsahu',
    generate_from_contour: 'Vytvořit z obrysu',
    grid_columns: 'Sloupce',
    grid_rows: 'Řádky',
    grid_spacing: 'Rozestupy (mm)',
    no_content: 'Ve vrstvách UV tisku není žádný obsah. Před použitím funkce Tisk a řez přidejte svůj návrh do vrstvy UV tisku.',
    no_layer_with_path: 'Žádná laserová vrstva neobsahuje vektorovou dráhu. Připravte laserovou vrstvu s řezací dráhou, abyste ji mohli použít jako obrys.',
    no_uv_layer: 'Nebyla nalezena žádná vrstva UV tisku. Chcete-li použít funkci Tisk a řez, změňte modul vrstvy s návrhem na „UV Tisk“.',
    open_preferences: 'Otevřít vlastnosti',
    orientation: 'Orientace',
    orientation_landscape: 'Na šířku',
    orientation_portrait: 'Na výšku',
    paper_size: 'Velikost výstupu',
    paper_too_small: 'Oblast výstupu je příliš malá. Návrh (včetně zarovnávacích značek) potřebuje alespoň %s mm okraje od hrany materiálu, aby zůstal v tisknutelné oblasti tiskárny. Zvolte větší velikost výstupu, jinak bude tisk oříznut nebo zmenšen.',
    preview_and_align: 'Náhled a zarovnání',
    resume_desc: 'Tento návrh je již připraven pro Tisk a řez.\nVložte do stroje další potištěný materiál a pokračujte k zarovnání kamerou, nebo začněte znovu a změňte návrh, velikost výstupu či řezací dráhu.',
    resume_title: 'Pokračovat v Tisk a řez',
    select_cut_layer: 'Vrstva s řezací dráhou',
    start_over: 'Začít znovu',
    step_align: 'Zarovnání kamerou',
    step_align_desc: 'Vložte potištěný materiál do stroje a spusťte náhled kamery.\nZnačky se rozpoznají a řezací linie se automaticky zarovnají s tiskem.\nKliknutím na „Dokončit“ přidáte zarovnanou řezací vrstvu na plátno; původní vrstvy návrhu budou skryty.\nPoté odešlete úlohu z editoru.',
    step_export: 'Exportovat a vytisknout PDF',
    step_export_desc: 'Exportujte PDF obsahující váš návrh a zarovnávací značky a vytiskněte jej na tiskárně ve 100% měřítku (skutečná velikost).\nNepoužívejte „Přizpůsobit stránce“, jinak řezací dráha nebude odpovídat tisku.\nOdsazené řezací dráhy nejsou zahrnuty, protože je používá pouze laserová řezačka.',
    step_paper: 'Velikost výstupu',
    step_paper_desc: 'Zvolte velikost výstupu pro exportované PDF.\nNastavte řádky a sloupce pro tisk a řezání více kopií vašeho návrhu na jednom kusu materiálu.\nNáhled zobrazuje hranici výstupu kolem obsahu.',
    step_setup: 'Řezací dráhy a značky',
    step_setup_desc: 'Zvolte, jak vytvořit řezací dráhu: vygenerovat obrys kolem celého návrhu, nebo použít stávající vrstvu jako řezací dráhu.',
    title: 'Tisk a řez',
    use_layer_as_cut_path: 'Použít vrstvu',
    uv_print_file_disabled: 'Funkce Tisk a řez tiskne obsah vrstev UV tisku. Nejprve ve vlastnostech povolte „Povolit UV tiskový soubor“ a přidejte svůj návrh do vrstvy UV tisku.',
    white_mark_base: 'Bílé pozadí pod značkami',
  },
  promark_connection_test: {
    description: 'Systém provede přibližně dvouminutový provoz červeného světla, aby zkontroloval stabilitu připojení.',
    health: 'Stabilita:',
    healthy_description: 'Stabilita je dobrá, ale během gravírování se vyhněte výraznému pohybu počítače.',
    res_0: 'Vynikající',
    res_1: 'Dobrá',
    res_2: 'Nízká',
    res_3: 'Velmi nízká',
    res_4: 'Extrémně nízká',
    restart: 'Restartovat test',
    start: 'Spustit test',
    stop: 'Zastavit test',
    title: 'Test stability připojení',
    unhealthy_description: 'Stabilita je příliš nízká. Doporučuje se vyměnit síťový adaptér nebo napájecí kabel.',
  },
  promark_settings: {
    angle: 'Úhel',
    bulge: 'Vyboulení',
    field: 'Pole',
    galvo_configuration: 'Konfigurace Galva',
    mark: 'Označit',
    mark_parameters: 'Parametry značení',
    offsetX: 'Posun X',
    offsetY: 'Posun Y',
    red_dot: 'Červená tečka',
    scale: 'Měřítko',
    scaleX: 'Měřítko X',
    scaleY: 'Měřítko Y',
    skew: 'Sklon',
    switchXY: 'Přepnout X/Y',
    title: 'Nastavení Promark',
    trapezoid: 'Trapezoid',
    workarea_hint: 'Pracovní plochu můžete změnit v "Nastavení dokumentu".',
    z_axis_adjustment: {
      section1: 'Upravte výšku osy Z pro doladění zaostření.',
      title: 'Nastavení osy Z',
      tooltip1: 'Zkuste označit čtverec 1x1 cm pro ověření, zda je aktuální ohnisková vzdálenost vhodná.',
    },
  },
  puzzle_generator: {
    bleed: 'Spadavka',
    board_base: 'Základní deska',
    board_radius: 'Poloměr rámu',
    board_width: 'Šířka rámu',
    change_image: 'Klikněte pro změnu obrázku',
    columns: 'Sloupce',
    design_preview: 'Náhled designu',
    exploded_view: 'Rozložený pohled',
    export_as: 'Exportovat jako',
    export_engrave: 'Vrstva gravírování',
    export_failed: 'Import puzzle na plátno se nezdařil. Zkuste to znovu nebo upravte nastavení puzzle.',
    export_none: 'Žádné',
    export_print: 'Vrstva tisku',
    file_too_large: 'Vybraný soubor překračuje maximální povolenou velikost.',
    guide_lines: 'Vodítka',
    heart_sharpness: 'Ostrost hrotu',
    image: 'Obrázek',
    image_load_failed: 'Načtení vybraného obrázku se nezdařilo. Zkuste jiný soubor.',
    image_resolution_warning: 'Rozlišení obrázku překračuje %(resolution)spx. To může ovlivnit kvalitu exportu nebo výkon.',
    import_to_canvas: 'Importovat na plátno',
    layers: {
      board_base: 'Základní deska',
      guide_lines: 'Vodicí čáry',
      image: 'Obrázek puzzle',
      pieces: 'Dílky puzzle',
      raised_edges: 'Zvýšené okraje',
    },
    offset_x: 'Posun X',
    offset_y: 'Posun Y',
    orientation: 'Orientace dílků',
    orientation_type_1: 'Typ 1',
    orientation_type_2: 'Typ 2',
    orientation_type_3: 'Typ 3',
    orientation_type_4: 'Typ 4',
    piece_size: 'Velikost dílků',
    preview_placeholder: 'Náhled puzzle',
    puzzle_board: 'Deska puzzle',
    puzzle_pieces: 'Dílky puzzle',
    radius: 'Poloměr',
    raised_edges: 'Vyvýšené hrany',
    reset_to_default: 'Obnovit výchozí',
    rows: 'Řádky',
    switch_type_warning: 'Vaše aktuální nastavení ještě nebyla importována na plátno.\nZměna typu puzzle obnoví všechna nastavení na výchozí hodnoty.',
    tab_size: 'Velikost záložky',
    types: {
      circle_jigsaw: 'Kruhové puzzle',
      heart_jigsaw: 'Srdcové puzzle',
      hex_jigsaw: 'Šestiúhelníkové puzzle',
      rectangle_jigsaw: 'Obdélníkové puzzle',
    },
    unsupported_file_type: 'Nepodporovaný typ souboru. Použijte JPG, PNG nebo WebP.',
    upload_hint: 'JPG, PNG, WebP (max. 10MB)',
    upload_image: 'Klikněte nebo přetáhněte pro nahrání',
    zoom: 'Přiblížení',
  },
  qr_code_generator: {
    error_tolerance: 'Chyba v toleranci',
    error_tolerance_link: 'https://support.flux3dp.com/hc/en-us/articles/9113705072143',
    invert: 'Obrátit barvu pozadí',
    placeholder: 'Zadejte text',
    title: 'Generátor QR kódu',
  },
  resolution: {
    title: 'Rozlišení',
    values: {
      detailed: 'Ultra Jemný',
      high: 'Jemný',
      low: 'Koncept',
      medium: 'Standardní',
      mixed: 'Smíšený',
      ultra: 'Ultra HD',
    },
  },
  rotary_settings: {
    circumference: 'Obvod',
    extend_workarea: 'Rozšířit pracovní oblast',
    mirror: 'Zrcadlo',
    object_diameter: 'Průměr objektu',
    overlap_size: 'Velikost překrytí',
    rotary_scale: 'Měřítko rotace',
    split_setting: 'Nastavení dělení',
    split_setting_url: 'https://support.flux3dp.com/hc/en-us/articles/12276094010767',
    split_size: 'Velikost dělení',
    type: 'Typ',
  },
  select_device: {
    auth_failure: '#811 Chyba při ověřování',
    select_device: 'Vybrat přístroj',
    unable_to_connect: '#810 Nepodařilo se navázat stabilní připojení s přístrojem',
  },
  settings: {
    anti_aliasing: 'Vyhlazování',
    auto_connect: 'Automaticky vybrat jediný přístroj',
    auto_switch_tab: 'Automatický přepínač panelu vrstev a objektů',
    autofocus_offset: 'Ofset autofokusu',
    autosave_enabled: 'Automatické ukládání',
    autosave_interval: 'Ukládat každé',
    autosave_number: 'Počet automaticky uložených pozic',
    autosave_path: 'Automatické místo ukládání',
    autosave_path_not_correct: 'Zvolená cesta nenalezena.',
    blade_precut_position: 'Pozice předřezu',
    blade_precut_switch: 'Předřez ostří',
    blade_radius: 'Poloměr ostří',
    bottom_up: 'Zezdola nahoru',
    calculation_optimization: 'Zrychlení výpočtu cesty',
    cancel: 'Storno',
    caption: 'Nastavení',
    check_updates: 'Automaticky kontrolovat aktualizace',
    close: 'Zavřít',
    confirm_remove_default: 'Výchozí přístroj bude odstraněn.',
    confirm_reset: 'Potvrdit restart Beam Studia?',
    continuous_drawing: 'Souvislé kreslení',
    crop_task_thumbnail: 'Náhled oříznutého obsahu',
    crop_task_thumbnail_tooltip: 'Zobrazte pouze miniaturu oblasti obsahující obsah, s vyloučením prázdných oblastí plátna.',
    custom_preview_height: 'Vlastní výška náhledu',
    default_beambox_model: 'Výchozí nastavení dokumentu',
    default_borderless_mode: 'Výchozí otevření spodní části',
    default_enable_autofocus_module: 'Výchozí autofokus',
    default_enable_diode_module: 'Výchozí diodový laser',
    default_font_family: 'Výchozí font',
    default_font_style: 'Výchozí styl fontu',
    default_laser_module: 'Modul výchozího laseru',
    default_machine: 'Výchozí přístroj',
    default_machine_button: 'Prázdný',
    default_units: 'Výchozí jednotky',
    diode_offset: 'Ofset diodového laseru',
    diode_one_way_engraving: 'Gravírování diodového laseru jedním směrem',
    diode_two_way_warning: 'Vysílání dvousměrového světla je rychlejší a pravděpodobně vygeneruje jisté nepřesnosti v pozici laserového gravírování. Doporučuje se nejprve otestovat.',
    disabled: 'Zakázáno',
    done: 'Použít',
    enable_custom_backlash: 'Povolit vlastní kompenzaci odporu',
    enable_low_speed: 'Povolit pomalý pohyb',
    enable_uv_print_file: 'Povolit UV tiskový soubor',
    enabled: 'Povoleno',
    engraving_direction: 'Směr',
    engraving_offset_tooltip: 'Pokud je výsledek gravírování posunut doleva nebo nahoru, snižte posun X/Y; pokud je posunut doprava nebo dolů, zvyšte posun X/Y.',
    fast_gradient: 'Optimalizace rychlosti',
    font_convert: 'Konvertor textu na cestu',
    font_substitute: 'Nahradit nepodporované znaky',
    grouped_objects: 'Skupina objektů',
    groups: {
      ador_modules: 'Moduly Ador',
      autosave: 'Automatické ukládání',
      beamo2_modules: 'beamo 2 moduly',
      camera: 'Kamera',
      connection: 'Připojení',
      editor: 'Editor',
      engraving: 'Rastrování (Skenování)',
      general: 'Obecné',
      mask: 'Výstřižek pracovní oblasti',
      module_settings: 'Nastavení modulu',
      module_type: 'Modul stroje',
      modules: 'Doplněk',
      path: 'Vektor (Obrys)',
      performance: 'Výkon',
      privacy: 'Soukromí',
      text: 'Text',
      text_to_path: 'Text',
      update: 'Softwarové aktualizace',
      workarea: 'Pracovní oblast',
    },
    guess_poke: 'Hledat IP adresu přístroje',
    guides: 'Vodítka',
    guides_origin: 'Počátky vodítek',
    help_center_urls: {
      anti_aliasing: 'https://support.flux3dp.com/hc/en-us/articles/360004408956',
      calculation_optimization: 'https://support.flux3dp.com/hc/en-us/articles/11146997425039',
      connection: 'https://support.flux3dp.com/hc/en-us/sections/360000302135',
      continuous_drawing: 'https://support.flux3dp.com/hc/en-us/articles/360004406496',
      default_borderless_mode: 'https://support.flux3dp.com/hc/en-us/articles/360001104076',
      default_enable_autofocus_module: 'https://support.flux3dp.com/hc/en-us/articles/360001574536',
      default_enable_diode_module: 'https://support.flux3dp.com/hc/en-us/articles/360001568035',
      fast_gradient: 'https://support.flux3dp.com/hc/en-us/articles/360004496235',
      font_convert: 'https://support.flux3dp.com/hc/en-us/articles/9132766761743',
      font_substitute: 'https://support.flux3dp.com/hc/en-us/articles/360004496575',
      image_downsampling: 'https://support.flux3dp.com/hc/en-us/articles/360004494995',
      loop_compensation: 'https://support.flux3dp.com/hc/en-us/articles/360004408856',
      mask: 'https://support.flux3dp.com/hc/en-us/articles/360004408876',
      segmented_engraving: 'https://support.flux3dp.com/hc/en-us/articles/12306366019215',
      simplify_clipper_path: 'https://support.flux3dp.com/hc/en-us/articles/360004407276',
      uv_print_export: 'https://support.flux3dp.com/hc/en-us/articles/12320887477135',
      vector_speed_constraint: 'https://support.flux3dp.com/hc/en-us/articles/360004496495',
    },
    high: 'Vysoká',
    image_downsampling: 'Kvalita bitmapového náhledu',
    ip: 'IP adresa přístroje',
    keep_preview_result: 'Ponechat Náhled Výsledku',
    language: 'Jazyk',
    loop_compensation: 'Kompenzace smyčky',
    low: 'Nízké',
    low_laser_for_preview: 'Laser pro rámování',
    mask: 'Výstřižek pracovní oblasti',
    medium: 'Střední',
    module_offset_2w_ir: 'Ofset 2W infračerveného laseru',
    module_offset_10w: 'Ofset 10W diodového laseru',
    module_offset_20w: 'Ofset 20W diodového laseru',
    module_offset_laser: 'Ofset laseru',
    module_offset_printer: 'Ofset tiskárny',
    none: 'Žádné',
    normal: 'Normální',
    notification_off: 'Vyp',
    notification_on: 'Zap',
    notifications: 'Oznámení na ploše',
    off: 'Vyp',
    on: 'Zap',
    preview_movement_speed: 'Rychlost pohybu v náhledu',
    printer_advanced_mode: 'Pokročilý mód tiskárny',
    printing_offset_tooltip: 'Pokud je výsledek tisku posunut doleva nebo nahoru, snižte posun X/Y; pokud je posunut doprava nebo dolů, zvyšte posun X/Y.',
    remove_default_machine_button: 'Odstranit',
    reset: 'Restartovat Beam Studio',
    reset_now: 'Restartovat Beam Studio',
    segmented_engraving: 'Segmentované gravírování',
    share_with_flux: 'Analýza Share Beam Studio',
    show_banners: 'Zobrazit banner domovské stránky',
    simplify_clipper_path: 'Optimalizace kotevních bodů',
    single_object: 'Jeden objekt',
    tabs: {
      device: 'Přístroj',
      general: 'Obecné',
    },
    text_path_calc_optimization: 'Optimalizace kalkulace cesty',
    top_down: 'Seshora dolů',
    trace_output: 'Výstup obkreslování obrázku',
    update_beta: 'Beta',
    update_latest: 'Poslední',
    use_real_boundary: 'Použít maximální rozsah',
    use_real_boundary_tooltip: 'Rozšiřte na skutečnou maximální pracovní oblast bez omezení celočíselnými mřížkovými čarami.',
    use_union_boundary: 'Zobrazit překrývající se pracovní oblast',
    use_union_boundary_tooltip: 'Zobrazit překrývající se pracovní oblasti více modulů',
    vector_order_optimization: 'Optimalizace pořadí vektorů',
    vector_speed_constraint: 'Omezení rychlosti',
    wrong_ip_format: 'Špatné formáty IP',
  },
  social_media: {
    facebook: 'Povídejte si s uživateli FLUX, ptejte se a naučte se tipy!',
    instagram: 'Získejte nejnovější inspirace, nabídky a dárky zdarma!',
    youtube: 'Podívejte se na návody Beam Studio a nápady na tvoření.',
  },
  stamp_maker_panel: {
    bevel_radius: 'Poloměr zkosení',
    horizontal_flip: 'Vodorovné převrácení',
    how_to: {
      text: 'Jak vyrobit razítko?',
      url: 'https://support.flux3dp.com/hc/en-us/articles/13658787903247',
    },
    invert: 'Invertovat',
    title: 'Výrobce razítek',
  },
  support: {
    no_vcredist: 'Nainstalujte prosím Visual C++ Redistributable 2015<br/> Ke stažení na flux3dp.com',
    no_webgl: 'WebGL není podporován. Použijte prosím jiná zařízení.',
  },
  tab_panel: {
    apply: 'Použít záložky',
    gap: 'Mezera',
    help_center: 'https://support.flux3dp.com/hc/en-us/articles/12441363882511',
    manual_mode: 'Manuální režim',
    title: 'Záložky',
  },
  tips: {
    canvas_hold_space_to_pan: 'Podržte mezerník a táhněte pro posunutí plátna.',
    feature_auto_fit: 'Po náhledu kamery použijte Akce → Automatické přizpůsobení pro automatické umístění objektů na materiál.',
    feature_box_generator: 'Použijte Generátory → Generátor krabic k vytvoření krabic na míru během několika sekund.',
    feature_code_generator: 'Použijte Generátory → Generátor čárových kódů k vytvoření QR kódů a čárových kódů.',
    feature_elements: 'Panel Prvky nyní obsahuje přes milion grafik připravených k použití.',
    feature_layer_color_configurations: 'Namapujte barvy vrstev SVG na rychlost a výkon pomocí Upravit → Vrstva → Nastavení barev.',
    feature_material_test: 'Použijte Generátory → Generátor testu materiálu v levém panelu nástrojů pro rychlé nalezení nejlepších nastavení pro materiál.',
    layer_execution_order: 'Pořadí vrstev určuje pořadí úloh. Úlohy se provádějí shora dolů.',
    machine_clean_mirror: 'Pravidelně kontrolujte zrcadla a fokusační čočku a v případě potřeby je čistěte, abyste předešli nahromadění kouře.',
    machine_no_unattended_operation: 'Nikdy nenechávejte stroj běžet bez dohledu.',
    machine_regular_start: 'Spouštějte laserovou úlohu alespoň jednou za dva týdny, abyste prodloužili životnost laserové trubice.',
    object_edit_image_to_erase: 'Použijte Obrázek → Akce → Upravit obrázek k vymazání nežádoucích oblastí na obrázku.',
    object_polygon_sides: 'Upravte počet stran v panelu vlastností polygonu.',
    object_rounded_rectangle: 'Nastavte poloměr rohu zaoblného obdélníku v panelu vlastností obdélníku.',
    object_sharpen_portrait: 'Vylepšete rytí portrétů pomocí Obrázek → Akce → Zostřit.',
    settings_auto_save: 'Povolte Automatické ukládání v Předvolbách, abyste předešli ztrátě své práce.',
    settings_default_text_font: 'V Předvolbách můžete nastavit výchozí písmo pro nástroj Text.',
    task_focus_lower_for_cutting: 'U tlustších materiálů může zaostření přibližně 2 mm pod povrchem zlepšit výsledky řezání.',
    task_leather_moisten_reduce_burn: 'Mírně navlhčete kůži před řezáním, abyste snížili stopy po spálení.',
    task_parameters_for_promark_color: 'Upravte šířku pulzu a frekvenci laserů MOPA pro vytvoření barev na nerezové oceli nebo titanu.',
    task_slower_for_smoother_acrylic_edge: 'Mírné snížení rychlosti řezání může vytvořit hladší hrany akrylu.',
    tips: 'Tipy:',
  },
  topbar: {
    alerts: {
      add_content_first: 'Nejprve prosím přidejte objekty.',
      close_door_before_framing: 'Zavřete prosím dvířka před spuštěním náhledu rámování.',
      door_opened: 'Uzavřete prosím dvířka, aby mohl laser nízké intenzity zahájit rámování.',
      fail_to_connect_with_camera: '#803 Nepodařilo se navázat spojení s kamerou. Restartujte prosím své zařízení nebo Beam Studio. Pokud bude tato chyba přetrvávat, přečtěte si prosím <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">tento návod</a>.',
      fail_to_get_door_status: 'Ujistěte se prosím, že jsou dvířka uzavřená, aby mohl laser nízké intenzity zahájit rámování.',
      fail_to_start_preview: '#803 Nepodařil se spustit náhled. Restartujte prosím své zařízení nebo Beam Studio. Pokud bude tato chyba přetrvávat, přečtěte si prosím <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">tento návod</a>.',
      headtype_mismatch: 'Nesprávný modul detekován.',
      headtype_none: 'Žádný modul nedetekován.',
      headtype_unknown: 'Neznámý modul detekován.',
      install_correct_headtype: 'Nainstalujte prosím správně moduly laserových diod 10W/20W, aby mohl laser nízké intenzity zahájit rámování.',
      job_origin_unavailable: 'Proces nastavení vodítek požaduje firmware verze 4.3.4 / 5.3.4 nebo vyšší. Chcete nyní aktualizovat firmware?',
      job_origin_warning: 'Momentálně používáte jako výchozí bod „aktuální pozici“. Ujistěte se, že je laserová hlava přesunuta do správné polohy, aby nedošlo ke kolizím.',
      object_outside_moving_area: 'Některé objekty přesahují oblast náhledu rámečku.',
      power_too_high: 'PŘÍLIŠ VYSOKÁ INTENZITA',
      power_too_high_confirm: 'ROZUMÍM',
      power_too_high_msg: 'Využívání nižší intenzity laseru (pod 70%) prodlouží životnost laserové trubice.\nStiskněte "ROZUMÍM" pro pokračování.',
      pwm_unavailable: 'Depth mode (režim hloubky) vyžaduje firmware verze 4.3.4 / 5.3.4 nebo vyšší. Chcete nyní aktualizovat firmware?',
      QcleanScene: 'Chcete vymazat kresbu?<br/> Smaže se tím i historie úprav!',
      start_preview_timeout: '#803 Během spuštění náhledu došlo k přerušení. Restartujte prosím své zařízení nebo Beam Studio. Pokud bude tato chyba přetrvávat, přečtěte si prosím <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001791895">tento návod</a>.',
      variable_text_warning: 'Tato úloha obsahuje proměnný text. Systém nejprve vyryje obsah proměnného textu a nebude postupovat podle pořadí vrstev.',
    },
    frame_task: 'Rámování',
    hint: {
      polygon: 'Pro zvyšování / snižování stran využívejte klávesy + / -.',
    },
    menu: {
      about: 'O Beam Studio',
      about_beam_studio: 'O Beam Studio',
      accessories: 'Příslušenství',
      account: 'Účet',
      add_new_machine: 'Nastavení přístroje',
      align_center: 'Zarovnat na střed',
      anti_aliasing: 'Vyhlazení',
      auto_align: 'Automatické Zarovnání',
      autofocus: {
        operating: 'Automatické zaostřování...',
        select_device_error: 'Před automatickým zaostřením prosím vyberte zařízení.',
        show_probe_error: 'Před automatickým zaostřením prosím zobrazte sondu.',
        title: 'Automatické zaostření',
      },
      borderless_mode: 'Mód bez okrajů',
      bug_report: 'Nahlásit chybu',
      calibrate_beambox_camera: 'Kalibrovat kameru',
      calibrate_beambox_camera_borderless: 'Kalibrovat kameru (otevřená spodní část)',
      calibrate_camera_advanced: 'Kalibrace kamery (Pokročilé)',
      calibrate_diode_module: 'Kalibrovat modul laserové diody',
      calibrate_ir_module: 'Kalibrovat infračervený modul',
      calibrate_print_and_cut: 'Kalibrovat Tisk a řez',
      calibrate_printer_module: 'Kalibrovat tiskový modul',
      calibrate_wide_angle_camera: 'Kalibrovat kameru (Širokoúhlá kamera)',
      calibration: 'Kalibrace',
      camera_calibration_data: 'Kalibrační data fotoaparátu',
      change_logs: 'Změnit záznamy',
      clear_scene: 'Nový',
      close: 'Zavřít okno',
      commands: 'Příkazy',
      contact: 'Kontaktujte nás',
      copy: 'Kopírovat',
      cut: 'Vyjmout',
      dashboard: 'Hlavní panel',
      decompose_path: 'Rozložit',
      delete: 'Smazat',
      design_market: 'Design Market',
      dev_tool: 'Debug nástroj',
      disassemble_use: 'Rozpojit',
      document_setting: 'Nastavení dokumentu',
      document_setting_short: 'Dokument',
      download_log: 'Záznamy stažení',
      download_log_canceled: 'Stahování záznamů zrušeno',
      download_log_error: 'Nastala neznámá chyba, zkuste to prosím později',
      duplicate: 'Duplikovat',
      edit: 'Úpravy',
      example_files: 'Příkladové soubory',
      export_BVG: 'BVG',
      export_calibration_data: 'Exportovat kalibrační data',
      export_flux_task: 'Úloha FLUX',
      export_JPG: 'JPG',
      export_PNG: 'PNG',
      export_SVG: 'SVG',
      export_to: 'Exportovat do...',
      export_UV_print: 'UV Tisk PDF',
      file: 'Soubor',
      fit_to_window: 'Přizpůsobit na velikost okna',
      follow_us: 'Sledujte nás',
      forum: 'Komunitní fórum',
      group: 'Sloučit do skupiny',
      help: 'Pomoc',
      help_center: 'Centrum nápovědy',
      hide: 'Skrýt Beam Studio',
      hideothers: 'Skrýt ostatní',
      image_crop: 'Oříznout',
      image_curve: 'Křivka',
      image_invert: 'Invertovat',
      image_sharpen: 'Zaostřit',
      image_stamp: 'Zkosit',
      image_vectorize: 'Obkreslit',
      import_acrylic_focus_probe: 'beamo & Beambox Fokusová sonda - 3 mm',
      import_ador_laser_example: 'Příklad Ador Laseru',
      import_ador_printing_example_full: 'Příklad Ador tisknutí - barevné',
      import_ador_printing_example_single: 'Příklad Ador tisknutí - jednobarevné',
      import_beambox_2_example: 'Příklad Beambox II',
      import_beambox_2_focus_probe: 'Beambox II Fokusová sonda - 3 mm',
      import_beamo_2_laser_example: 'Příklad beamo II Laseru',
      import_beamo_2_printing_example: 'Příklad beamo II tisknutí',
      import_beamo_2_printing_test: 'Test tisknutí beamo II',
      import_calibration_data: 'Importovat kalibrační data',
      import_hello_beambox: 'Příklady Beambox',
      import_hello_beamo: 'Příklady beamo',
      import_hexa_example: 'Příklad HEXA',
      import_hexa_rf_example: 'Příklad HEXA RF',
      import_material_printing_test: 'Test tisknutí materiálu',
      import_material_testing_cut: 'Test řezání materiálu',
      import_material_testing_engrave: 'Test gravírování materiálu',
      import_material_testing_line: 'Test linkování materiálu',
      import_material_testing_old: 'Test gravírování materiálu - Klasický',
      import_material_testing_simple_cut: 'Test řezání materiálu - Jednoduchý',
      import_promark_engraving_example_1: 'Příklad gravírování Promark I',
      import_promark_engraving_example_2: 'Příklad gravírování Promark II',
      import_promark_example: 'Příklad Promarku',
      import_promark_mopa_20w_color: 'MOPA 20W Test Barev',
      import_promark_mopa_60w_color: 'MOPA 60W Test Barev',
      import_promark_mopa_100w_color: 'MOPA 100W Test Barev',
      keyboard_shortcuts: 'Klávesové zkratky',
      layer_color_config: 'Nastavení barev',
      layer_setting: 'Vrstva',
      link: {
        autocad: 'https://support.flux3dp.com/hc/en-us/articles/16590795274895',
        beam_studio_api: 'https://github.com/flux3dp/beam-studio/wiki/Beam-Studio-Easy-API',
        contact_us: 'https://support.flux3dp.com/hc/en-us/requests/new',
        design_market: 'https://dmkt.io',
        downloads: 'https://flux3dp.com/downloads/',
        forum: 'https://www.facebook.com/groups/flux.laser/',
        help_center: 'https://helpcenter.flux3dp.com/',
        shortcuts: 'https://support.flux3dp.com/hc/en-us/articles/10003978157455',
      },
      log: {
        camera: 'Kamera',
        cloud: 'Cloud',
        discover: 'Objevit',
        hardware: 'Hardware',
        network: 'Síť',
        player: 'Přehrávač',
        robot: 'Robot',
        usb: 'USB',
        usblist: 'Seznam USB',
      },
      login_or_register: 'Přihlásit se nebo zaregistrovat',
      logout: 'Odhlásit se',
      machine_info: 'Informace o přístroji',
      machines: 'Přístroje',
      maintenance_checklist: 'Kontrolní seznam údržby',
      manage_account: 'Nastavit Můj účet',
      material_test: 'Test materiálu',
      minimize: 'Minimalizovat',
      my_account: 'Můj účet',
      network_testing: 'Testovat nastavení sítě',
      object: 'Objekt',
      offset: 'Ofset',
      open: 'Otevřít',
      paste: 'Vložit',
      paste_in_place: 'Vložit na místo',
      path: 'Cesta',
      photo_edit: 'Obrázek',
      plugin: 'Zásuvný modul',
      preferences: 'Vlastnosti',
      questionnaire: 'Dotazník se zpětnou vazbou',
      quit: 'Ukončit',
      recent: 'Otevřít poslední',
      redo: 'Znovu',
      reload_app: 'Znovu načíst aplikaci',
      reset: 'Restartovat',
      reset_layout: 'Obnovit rozložení',
      rotary_setup: 'Nastavení rotačního zařízení',
      rotate: 'Otočit',
      samples: 'Příklady',
      save_as: 'Uložit jako...',
      save_scene: 'Uložit',
      save_to_cloud: 'Uložit do cloudu',
      scale: 'Škálovat',
      service: 'Služby',
      set_as_default: 'Nastavit jako výchozí',
      show_gesture_tutorial: 'Návod k dotykovým gestům',
      show_grids: 'Zobrazit mřížky',
      show_layer_color: 'Použít barvu vrstvy',
      show_rulers: 'Zobrazit pravítka',
      show_start_tutorial: 'Ukázat Úvodní výuku',
      show_ui_intro: 'Ukázat Úvod do uživatelského rozhraní',
      software_update: 'Aktualizace softwaru',
      svg_edit: 'SVG',
      switch_to_beta: 'Přepnout na beta verzi',
      switch_to_latest: 'Přepnout na stabilní verzi',
      tab_layers: 'Vrstvy',
      tab_objects: 'Objekty',
      tab_path_edit: 'Upravit cestu',
      tools: {
        title: 'Nástroje',
      },
      tutorial: 'Zahájit výuku k Delta Family Printing',
      undo: 'Zpět',
      ungroup: 'Rozdělit skupinu',
      update: 'Kontrola aktualizací',
      update_firmware: 'Aktualizovat firmware',
      update_machine: 'Aktualizovat stroj',
      update_mainboard: 'Aktualizovat základní desku',
      update_printer_board: 'Aktualizovat řídicí desku tiskárny',
      using_beam_studio_api: 'Využívání Beam Studio API',
      view: 'Zobrazit',
      window: 'Okno',
      zoom_in: 'Přiblížit',
      zoom_out: 'Oddálit',
      zoom_with_window: 'Automaticky přizpůsobit na velikost okna',
    },
    rename_tab: 'Přejmenovat kartu',
    select_machine: 'Vybrat přístroj',
    tag_names: {
      dxf: 'DXF objekt',
      ellipse: 'Ovál',
      fit_text: 'Textové pole',
      g: 'Skupina',
      image: 'Obrázek',
      line: 'Linka',
      multi_select: 'Několik objektů',
      no_selection: 'Žádný výběr',
      params_label: 'Štítek parametrů',
      pass_through_object: 'Procházet objektem',
      path: 'Cesta',
      polygon: 'Polygon',
      rect: 'Obdélník',
      svg: 'SVG objekt',
      text: 'Text',
      text_path: 'Text na cestě',
      use: 'Importovaný objekt',
    },
    task_preview: 'Náhled cesty',
    untitled: 'Bez názvu',
  },
  topmenu: {
    credit: 'Beam Studio bylo vytvořeno díky open source projektu <a target="_blank" href="https://github.com/flux3dp/beam-studio">Beam Studio</a> a dalšímu <a target="_blank" href="https://flux3dp.com/credits/">open source softwaru</a>.',
    device: {
      download_log_canceled: 'Stažení záznamu zrušeno.',
      download_log_error: 'Nastala neznámá chyba, zkuste to prosím znovu později.',
      log: {
        usblist: 'Seznam USB',
      },
      network_test: 'Otestovat síť',
    },
    file: {
      all_files: 'Všechny soubory',
      clear_recent: 'Vyčistit nedávno otevřené',
      converting: 'Konvertovat na Obrázek...',
      fcode_files: 'FLUX kód',
      import: 'Importovat',
      jpg_files: 'JPG',
      label: 'Soubor',
      path_not_exit: 'Zdá se, že tato cesta už na disku neexistuje.',
      png_files: 'PNG',
      save_fcode: 'Exportovat FLUX úlohu',
      save_jpg: 'Exportovat JPG',
      save_pdf: 'Exportovat PDF',
      save_png: 'Exportovat PNG',
      save_scene: 'Uložit scénu',
      save_svg: 'Exportovat SVG',
      scene_files: 'Plocha Beam Studio',
      svg_files: 'SVG',
    },
    version: 'Verze',
  },
  tutorial: {
    ask_retry_calibration: 'Přejete si znovu kalibrovat kameru?',
    camera_calibration_failed: 'Kalibrace kamery selhala',
    gesture: {
      click: 'Poklepejte k vybrání objektu.',
      drag: 'Přetáhněte k vybrání několika objektů.',
      hold: 'Stiskněte a držte k otevření kontextového menu.',
      pan: 'Posouvejte plátno dvěma prsty.',
      zoom: 'Udělejte "špetku" dvěma prsty k přiblížení a oddálení plátna.',
    },
    links: {
      adjust_focus: 'https://support.flux3dp.com/hc/en-us/articles/360001684196',
    },
    look_for_machine: 'Hledám přístroj pro výuku...',
    needNewInterfaceTutorial: 'Přejete si nyní spustit výuku pro nové rozhraní Beam Studio?<br/>(Můžete ji nyní přeskočit a později spustit přes "Pomoc" > "Úvod do uživatelského rozhraní".)',
    needNewUserTutorial: 'Přejete si spustit výuku?<br/>(Můžete ji nyní přeskočit a později spustit přes "Pomoc" > "Ukázat Úvodní výuku".)',
    newInterface: {
      add_new_layer: 'Přidat novou vrstvu',
      align_controls: 'Ovládací prvky zarovnání',
      basic_shapes: 'Základní tvary',
      camera_preview: 'Náhled kamery',
      drag_to_sort: 'Táhnout k seřazení',
      end_alert: 'Opravdu si přejete ukončit představení nového uživatelského rozhrání?',
      flip: 'Převrátit',
      group_controls: 'Ovládací prvky skupin',
      layer_controls: 'Pravé tlačítko k výběru Ovládání vrstev:\nDuplikovat / Sloučit / Zamknout / Smazat vrstvy',
      object_actions: 'Akce objektů',
      pen_tool: 'Nástroj propiska',
      rename_by_double_click: 'Přejmenovat dvojitým kliknutím',
      select_image_text: 'Výběr / Obrázek / Text',
      select_machine: 'Vyberte přístroj',
      shape_operation: 'Práce s tvary',
      start_work: 'Zahájit práci',
      switch_between_layer_panel_and_object_panel: 'Přepínání mezi Panelem vrstev a Panelem objektů',
    },
    newUser: {
      add_new_layer: 'Přidat novou vrstvu',
      adjust_focus: '2. Přizpůsobit fokus',
      close_cover: '3. Zavřít dvířka',
      drag_to_draw: 'Táhnout k nakreslení',
      draw_a_circle: 'Nakreslit kruh',
      draw_a_rect: 'Nakreslit obdélník',
      end_alert: 'Jste si jistý, že chcete ukončit výuku?',
      end_preview_mode: 'Ukončit mód náhledu',
      infill: 'Zapnout výplň',
      please_select_wood_cutting: 'Vyberte prosím předvolbu "Dřevo - řez".',
      please_select_wood_engraving: 'Vyberte prosím předvolbu "Dřevo - gravírování".',
      preview_the_platform: 'Náhled platformy',
      put_wood: '1. Vložte vzorek dřeva',
      send_the_file: 'Poslat soubor',
      set_preset_wood_cut: 'Nastavit předvolbu: Dřevo - řez',
      set_preset_wood_engraving: 'Nastavit předvolbu: Dřevo - gravírování',
      start_tutorial: 'Úvodní výuka',
      switch_to_layer_panel: 'Přepnout na panel vrstev',
      switch_to_object_panel: 'Přepnout na panel objektů',
      switch_to_preview_mode: 'Přepnout na mód náhledu',
    },
    next: 'DALŠÍ',
    retry: 'Opakovat',
    set_connection: 'Nastavit připojení',
    skip: 'Přeskočit',
    skip_tutorial: 'Přeskočil jste výuku. Můžete ji kdykoliv spustit přes "Pomoc" > "Ukázat Úvodní výuku"',
    suggest_calibrate_camera_first: 'Doporučujeme uživatelům před každým náhledem nejprve kalibrovat kameru a znovu provést fokus pro optimální výsledky.<br/>Potvrďte prosím, že si nyní přejete kalibrovat.<br/>(Můžete toto přeskočit a později udělat přes "Menu" > "Přístroj" > [Váš přístroj] > "Kalibrovat kameru".)',
    tutorial_complete: 'To je z výuky vše. Nyní je čas tvořit!',
    unable_to_find_machine: 'Nepodařilo se najít přístroj pro Výuku. Přejete si jít do nastavení připojení, opakovat nebo výuku přeskočit?',
    welcome: 'VÍTEJTE',
  },
  update: {
    cannot_reach_internet: '#823 Server není dosažitelný<br/> Zkontrolujte prosím internetové připojení',
    download: 'ONLINE AKTUALIZACE',
    firmware: {
      caption: 'Aktualizace firmwaru k tomuto přístroji je k dispozici',
      confirm: 'UPLOAD',
      firmware_too_old_update_by_sdcard: 'Verze firmwaru je příliš stará. Aktualizujte prosím firmware SD kartou.',
      force_update_message: '#814 Aktualizujte prosím svůj přístroj na nejaktuálnější verzi firmwaru.',
      latest_firmware: {
        cant_get_latest: 'Nepodařilo se získat informace k nejaktuálnějšímu firmwaru.',
        caption: 'Aktualizace firmwaru přístroje.',
        message: 'Máte nejaktuálnější firmware přístroje.',
        still_update: 'AKTUALIZACE',
      },
      message_pattern_1: '"%s" je nyní připraven k aktualizaci firmwaru.',
      message_pattern_2: '%s firmware v%s je nyní k dispozici - Máte v%s.',
      too_old_for_web: 'Současná verze firmwaru vašeho přístroje je v%s.\nPokud chcete použít online verzi Beam Studia, aktualizujte prosím firmware přístroje na nejaktuálnější verzi.',
      update_fail: '#822 Selhání při aktualizaci',
      update_success: 'Aktualizace firmwaru úspěšně nahrána',
      upload_firmware_title: 'Upload firmwaru (*.fxfw)',
      upload_mainboard_title: 'Nahrání firmwaru základní desky (*.bin)',
      upload_printer_board_title: 'Nahrání firmwaru tiskové desky (*.bin)',
    },
    install: 'INSTALOVAT',
    later: 'POZDĚJI',
    preparing: 'Připravuji...',
    release_note: 'Poznámka k verzi:',
    skip: 'Přeskočit tuto verzi',
    software: {
      available_switch: 'Beam Studio v%s je nyní k dispozici. Máte v%s. Chcete přejít na tuto verzi?',
      available_update: 'Beam Studio v%s je nyní k dispozici. Máte v%s. Chcete stáhnout aktualizaci?',
      caption: 'Aktualizace softwaru pro Beam Studio je k dispozici.',
      check_update: 'Kontrola aktualizace',
      checking: 'Kontroluji aktualizace',
      downloading: 'V pozadí se stahují aktualizace, kliknutím na tlačítko "OK" můžete pokračovat ve své práci.',
      install_or_not: 'je připraven k aktualizaci. Chcete nyní restartovat a aktualizovat?',
      no: 'Ne',
      no_response: 'Nepodařilo se připojit k serveru, zkontrolujte prosím nastavení sítě.',
      not_found: 'Používáte nejaktuálnější verzi Beam Studio.',
      switch_or_not: 'je připraven k výměně. Chcete nyní restartovat a vyměnit?',
      switch_version: 'Změnit verzi',
      switch_version_not_found: 'Vyměnitelná verze nenalezena.',
      update_for_ador: 'Současná verze softwaru %s není kompatibilní, stáhněte prosím nejaktuálnější verzi Beam Studia pro Ador.',
      yes: 'Ano',
    },
    update: 'Aktualizace',
    updating: 'Aktualizuji...',
    upload: 'NAHRÁT',
  },
  variable_text_settings: {
    advance_by: 'Posunout o',
    auto_advance: 'Automatický posun',
    auto_advance_hint: 'Při každém spuštění úlohy se automaticky přesune na další proměnná data.',
    bake: 'Dokončit',
    bake_description: 'Odstranit variabilitu a převést na běžný text',
    browse: 'Prohlížet',
    clear: 'Vymazat',
    csv_file: 'CSV soubor',
    current: 'Aktuální',
    end: 'Konec',
    failed_to_convert: 'Objekt s proměnným textem obsahuje nepodporovaný formát, což může způsobit, že se obsah nezobrazí.',
    file_error: 'Nepodařilo se analyzovat CSV soubor, zkontrolujte prosím formát souboru.',
    file_size_exceeded: 'Nahrání souboru selhalo, velikost souboru překračuje 5 MB.',
    next: 'Další',
    note: 'Toto nastavení se automaticky použije na všechny proměnné texty',
    previous: 'Předchozí',
    start: 'Start',
    test: 'Test',
    test_description: 'Stiskněte a podržte pro zobrazení proměnného textu',
    title: 'Nastavení proměnných textů',
  },
  web_cam: {
    image_to_small: 'Velikost obrazu z kamery je příliš malá. Obrázek může být poškozen.',
    no_device: 'Nelze detekovat kamerové zařízení. Znovu připojte kameru a zkuste to znovu.',
    no_permission: 'Beam Studio nemá oprávnění k přístupu k kameře. Ujistěte se, že je v nastavení prohlížeče nebo systému uděleno oprávnění pro Beam Studio.',
  },
  welcome_page: {
    follow_us: {
      subtitle: 'Získejte inspiraci, nabídky, dárky a zapojte se do komunity FLUX!',
      user_group: 'Uživatelská skupina',
    },
    help_center: {
      guides: 'Průvodce',
      guides_subtitle: 'Zobrazit komplexní návody ke všem produktům FLUX.',
      submit_request: 'Odeslat žádost',
      subtitle: 'Průvodci, příručky a podpůrné zdroje pro vše, co se týká FLUX.',
      visit_help_center: 'Navštívit centrum nápovědy',
    },
    member_center: 'Centrum členů',
    member_center_url: 'https://member.flux3dp.com/en-US/machine-register',
    new_project: 'Nový projekt',
    not_login_placeholder: 'Získejte od nás bezplatné AI kredity při registraci účtu FLUX!',
    recent_files: 'Nedávné soubory',
    shop: 'Obchod',
    shop_products: 'Koupit produkty FLUX',
  },
  z_speed_limit_test: {
    alert_before: 'Před zahájením rytí křivky systém provede zátěžový test, aby zabránil ztrátě kroků v důsledku nadměrné hmotnosti.',
    alert_failed: 'Hmotnost aktuálního objektu překračuje limit zatížení pro aktuální rychlost osy Z. Snižte prosím rychlost osy Z na ovládacím panelu stroje nebo vyměňte gravírovaný objekt před opětovným testováním.',
    ignore: 'Ignorovat',
    retest: 'Otestovat znovu',
    testing: 'Provádí se zátěžový test...',
  },
};

export default lang;
